import { useState, useEffect, useRef } from "react";
import { ChevronLeft } from "lucide-react";
import axios from "axios";
import { ToastContainer, toast, cssTransition } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "./home.css";
import { MdPhone } from "react-icons/md";
// Add AOS imports
import AOS from "aos";
import "aos/dist/aos.css";
import { Link } from "react-router-dom";

import renuka from "../../../assets/images/Doctorsimages/dr.renuka_new.png";
import pavithra from "../../../assets/images/Doctorsimages/dr.pavithra.png";
import muthumari from "../../../assets/images/Doctorsimages/dr.muthumari.png";
import yuganthi from "../../../assets/images/Doctorsimages/dr.yuganthi.png";
import aswini from "../../../assets/images/Doctorsimages/dr.aswini.png";
import ahilan from "../../../assets/images/Doctorsimages/dr.Ahilan_new.png";
import pargavi from "../../../assets/images/Doctorsimages/dr.pargavi.png";

import banner1 from "../../../assets/images/banner/Artboard1.jpg";
import banner2 from "../../../assets/images/banner/Artboard2.jpg";
import banner3 from "../../../assets/images/banner/Artboard3.jpg";
import banner4 from "../../../assets/images/banner/Artboard5.jpg";
import banner5 from "../../../assets/images/banner/Artboard4.jpg";
import banner6 from "../../../assets/images/banner/banner6.jpg";

import homeConsultation from "../../../assets/images/homeConsultation.jpg";
import hair from "../../../assets/images/home-hair1.jpg";
import homeskin from "../../../assets/images/home-skin4.jpg";
import homedental from "../../../assets/images/home-dental.jpg";
import homehomeopathy from "../../../assets/images/home-homeopathy.jpg";

import bannerjayanagar from "../../../assets/images/homeopathyjayanagarclinic.jpg";
import bannervalasaravakkam from "../../../assets/images/banner/valasaravakaminterier.jpg";
import bannervalasaravakkam1 from "../../../assets/images/banner/valasaravakaminterier1.jpg";
import gerukambakkminterior from "../../../assets/images/banner/gerukambakkminterior.jpg";
import tambaraminterior from "../../../assets/images/banner/tambaraminterior.jpg";

import googleIcon from "../../../assets/images/google-icon.png";

import yuvapriya from "../../../assets/images/Doctorsimages/dr.yuvapriya.png";
import veenadoc from "../../../assets/images/Doctorsimages/dr.veena.png";
import spoorthi from "../../../assets/images/Doctorsimages/dr.spoothi_new.png";
import Chayanika from "../../../assets/images/Doctorsimages/dr.Chayanika.png";
import DHARSHANDR from "../../../assets/images/Doctorsimages/DHARSHANDR.png";
import NELOFARDOC from "../../../assets/images/Doctorsimages/NELOFARDOC.png";
import UMABARATHIDR from "../../../assets/images/Doctorsimages/UMABARATHIDR.png";
import sarbarmathydr from "../../../assets/images/Doctorsimages/sarbarmathydr.png";

import img1 from "../../../assets/images/autoscroll1.jpg";
import img2 from "../../../assets/images/autoscroll2.jpg";
import img3 from "../../../assets/images/autoscroll3.jpg";
import img4 from "../../../assets/images/autoscroll4.jpg";
import img5 from "../../../assets/images/autoscroll5.jpg";
import img6 from "../../../assets/images/autoscroll6.jpg";
import img7 from "../../../assets/images/autoscroll7.jpg";
import img8 from "../../../assets/images/autoscroll8.jpg";
import img9 from "../../../assets/images/autoscroll9.jpg";
import img10 from "../../../assets/images/autoscroll10.jpg";
import img11 from "../../../assets/images/autoscrollskin1.png";
import img12 from "../../../assets/images/autoscrollskin2.png";
import img13 from "../../../assets/images/autoscrollskin3.png";
import img14 from "../../../assets/images/autoscrollskin4.png";
import img15 from "../../../assets/images/autoscrollskin5.png";
import img16 from "../../../assets/images/autoscrollskin6.png";
import img17 from "../../../assets/images/autoscrollskin7.png";
import img18 from "../../../assets/images/autoscrollskin8.png";
import img19 from "../../../assets/images/autoscrollskin9.png";
import img20 from "../../../assets/images/autoscrollskin10.png";

// Add these imports at the top of your home.jsx file with your existing imports
import hairFall from "../../../assets/images/banner/gfc.jpg";
import alopecia from "./../../../assets/images/adanced-growhair6.jpg";
import acne from "../../../assets/images/banner/home-hydrafacial.jpg";
import pigmentation from "../../../assets/images/banner/home-faceprp.jpg";
import psoriasis from "../../../assets/images/chennaitambarammainskin.jpg";
import eczema from "../../../assets/images/banner/faceacne.jpg";
import migraine from "../../../assets/images/banner/home-migrain.jpg";
import thyroid from "../../../assets/images/banner/home-thyroid.jpg";
import asthma from "../../../assets/images/banner/home-asthma.jpg";
import dandruff from '../../../assets/images/chennaitambaramqr678.jpg';
import thinning from "../../../assets/images/banner/home-prp.jpg";
import pcod from "../../../assets/images/PCODPCOS1.jpg";
import exos from "../../../assets/images/banner/exos5.jpg";
import qr678 from "../../../assets/images/banner/qr678new.png";
import meso from "../../../assets/images/banner/meso.jpg";
import exosomes from "../../../assets/images/banner/iliyas.png";
import faceexos  from "../../../assets/images/banner/faceexos4.jpg";
import facegfc  from "../../../assets/images/banner/facegfc.jpg";
import faceco2  from "../../../assets/images/banner/faceco2.jpg";
import facehairremoval  from "../../../assets/images/banner/facehairremoval.jpg";
import infertility  from "../../../assets/images/banner/infertility.jpg";

import dentalImplant from "../../../assets/images/dentalimages/DentalImplants.jpg";
import braces from "../../../assets/images/dentalimages/Orthodontics.jpeg";
import teethWhitening from "../../../assets/images/dentalimages/PediatricDentistry.jpg";
import rootCanal from "../../../assets/images/dentalimages/Endodontics.jpg";

const testimonialsData = [
  {
    name: "Rahul Sharma",
    text: "H-Cura Clinic really transformed my hair with their PRP treatment. The doctors explained everything clearly, and I started seeing results in just a few sessions. The clinic was super clean and welcoming. Highly recommended for anyone facing hair loss issues. I felt very comfortable throughout the treatment journey and would definitely visit again for follow-ups.",
  },
  {
    name: "Ananya Gupta",
    text: "I had severe acne problems, but the skin specialists at H-Cura worked wonders. They suggested laser treatment combined with skincare routines. The results were better than I expected. I feel more confident and happy now! Their approach is professional yet very friendly. The team keeps checking up on me to make sure my skin is improving steadily.",
  },
  {
    name: "Mohammed Iliyas",
    text: "I visited H-Cura for dental implants. The process was smooth, painless, and professional. The doctors are highly skilled and use modern technology. My smile looks natural again, and I can't thank them enough for the care and support I received throughout the journey. They gave me multiple treatment options and explained costs transparently.",
  },
  {
    name: "Sneha Reddy",
    role: "Teacher",
    text: "I had been struggling with hair thinning for years. After consulting many clinics, I finally chose H-Cura. The PRP sessions were effective and painless. The staff is friendly, and the clinic ambiance is modern and relaxing. Within three months, I noticed a huge difference in my hair density and quality.",
  },
  {
    name: "Vikram Kumar",
    role: "Bank Manager",
    text: "I went for a dental cleaning and cavity filling. The doctors explained the whole process in simple words and made me feel at ease. The clinic uses advanced tools and hygiene is top-notch. My treatment was quick and smooth, and the results are excellent. Highly recommend H-Cura for dental care.",
  },
];

// Testimonials Components
const StarRating = () => (
  <div className="stars">
    {Array(5)
      .fill("★")
      .map((star, i) => (
        <span key={i} className="star">
          {star}
        </span>
      ))}
  </div>
);

const TestimonialCard = ({ name, role, text, onToggleExpand }) => {
  const [expanded, setExpanded] = useState(false);

  const toggleExpand = () => {
    const newState = !expanded;
    setExpanded(newState);
    onToggleExpand(newState);
  };

  const handleCardClick = () => {
    // Replace with your actual Google review URL
    window.open(
      "https://www.google.com/maps/place/H-Cura+Multispeciality+Clinic,+Jayanagar-+Bangalore+%7C+Best+in+Homeopathy,+Skin,+Hair,+and+Dental/@12.9170114,77.5931846,17z/data=!4m8!3m7!1s0x3bae14d8dd315555:0x837b338b42d71825!8m2!3d12.9170062!4d77.5957595!9m1!1b1!16s%2Fg%2F11sh00v1sz?hl=en-IN&entry=ttu&g_ep=EgoyMDI1MTAwOC4wIKXMDSoASAFQAw%3D%3D",
      "_blank"
    );
  };

  return (
    <div
      className="testimonial-card"
      onClick={handleCardClick}
      style={{ cursor: "pointer" }}
    >
      <p className={`testimonial-text \${expanded ? "expanded" : ""}`}>{text}</p>
      {text.split(" ").length > 25 && (
        <button
          onClick={(e) => {
            e.stopPropagation();
            toggleExpand();
          }}
          className="read-more-btn"
        >
          {expanded ? "Read Less" : "Read More"}
        </button>
      )}
      <div className="testimonial-footer">
        <div className="google-info">
          <img src={googleIcon} alt="Google" className="google-icon" />
          <div>
            <h4>{name}</h4>
            <span>{role}</span>
            <StarRating />
          </div>
        </div>
        {/* Add Google review indicator */}
        <div className="google-review-indicator">⭐ Click to Review</div>
      </div>
    </div>
  );
};

const Testimonials = () => {
  const scrollRef = useRef(null);
  const intervalRef = useRef(null);
  const isPausedRef = useRef(false);

  const startScrolling = () => {
    const scrollContainer = scrollRef.current;
    if (!scrollContainer) return;

    let scrollAmount = 1.2;
    intervalRef.current = setInterval(() => {
      if (!isPausedRef.current) {
        scrollContainer.scrollLeft += scrollAmount;
        if (scrollContainer.scrollLeft >= scrollContainer.scrollWidth / 2) {
          // Temporarily disable smooth scroll behavior for an instant jump
          scrollContainer.style.scrollBehavior = 'auto';
          scrollContainer.scrollLeft = 0;
          // Re-enable smooth scroll behavior after a very short delay
          setTimeout(() => {
            if (scrollContainer) { // Check if container still exists
              scrollContainer.style.scrollBehavior = 'smooth';
            }
          }, 50);
        }
      }
    }, 30);
  };

  const stopScrolling = () => {
    clearInterval(intervalRef.current);
  };

  // Manual scroll functions
  const scrollLeft = () => {
    const scrollContainer = scrollRef.current;
    if (scrollContainer) {
      // Pause auto-scroll temporarily
      isPausedRef.current = true;
      scrollContainer.scrollBy({ left: -350, behavior: "smooth" });

      // Resume auto-scroll after 3 seconds
      setTimeout(() => {
        isPausedRef.current = false;
      }, 3000);
    }
  };

  const scrollRight = () => {
    const scrollContainer = scrollRef.current;
    if (scrollContainer) {
      // Pause auto-scroll temporarily
      isPausedRef.current = true;
      scrollContainer.scrollBy({ left: 350, behavior: "smooth" });

      // Resume auto-scroll after 3 seconds
      setTimeout(() => {
        isPausedRef.current = false;
      }, 3000);
    }
  };

  useEffect(() => {
    if (window.innerWidth > 768) {
      startScrolling();

      const scrollContainer = scrollRef.current;
      const handleEnter = () => {
        isPausedRef.current = true;
      };
      const handleLeave = () => {
        isPausedRef.current = false;
      };

      scrollContainer.addEventListener("mouseenter", handleEnter);
      scrollContainer.addEventListener("mouseleave", handleLeave);

      return () => {
        stopScrolling();
        scrollContainer.removeEventListener("mouseenter", handleEnter);
        scrollContainer.removeEventListener("mouseleave", handleLeave);
        // Ensure scroll behavior is reset on unmount
        if (scrollContainer) {
            scrollContainer.style.scrollBehavior = 'smooth';
        }
      };
    }
  }, []);

  useEffect(() => {
    if (window.innerWidth <= 768) {
      const scrollContainer = scrollRef.current;
      let index = 0;

      const autoSlide = () => {
        index = (index + 1) % testimonialsData.length;
        scrollContainer.scrollTo({
          left: index * scrollContainer.clientWidth,
          behavior: "smooth",
        });
      };

      const interval = setInterval(autoSlide, 4000);
      return () => clearInterval(interval);
    }
  }, []);

  const duplicatedData = [...testimonialsData, ...testimonialsData];
  
  return (
     <section className="hcura-testimonials-section">
      <div className="hcura-testimonials-container">
        <div className="hcura-testimonials-header">
          <div className="hcura-testimonials-subtitle">Patient Stories</div>
          <h2 className="hcura-testimonials-title">
            What Our{" "}
            <span className="hcura-testimonials-gradient-text">Patients</span>{" "}
            Say
          </h2>

          {/* Google Review Button */}
          <div className="hcura-google-review-section">
            <a
              href="https://www.google.com/maps/place/H-Cura+Multispeciality+Clinic,+Jayanagar-+Bangalore+%7C+Best+in+Homeopathy,+Skin,+Hair,+and+Dental/@12.9170114,77.5931846,17z/data=!4m8!3m7!1s0x3bae14d8dd315555:0x837b338b42d71825!8m2!3d12.9170062!4d77.5957595!9m1!1b1!16s%2Fg%2F11sh00v1sz?hl=en-IN&entry=ttu&g_ep=EgoyMDI1MTAwOC4wIKXMDSoASAFQAw%3D%3D"
              target="_blank"
              rel="noopener noreferrer"
              className="hcura-google-review-btn"
            >
              ⭐ Leave a Google Review
            </a>
          </div>
        </div>

        {/* Testimonials with Navigation Buttons */}
        <div className="testimonials-section-wrapper">
          {/* Left Scroll Button */}
          <button
            className="testimonials-scroll-btn testimonials-scroll-left"
            onClick={scrollLeft}
            aria-label="Scroll testimonials left"
          >
            <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
              <path d="M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z" />
            </svg>
          </button>

          <div className="testimonials-wrapper" ref={scrollRef}>
            {duplicatedData.map((t, i) => (
              <TestimonialCard
                key={i}
                {...t}
                onToggleExpand={(expanded) => {
                  if (expanded) {
                    isPausedRef.current = true;
                  } else {
                    isPausedRef.current = false;
                  }
                }}
              />
            ))}
          </div>

          {/* Right Scroll Button */}
          <button
            className="testimonials-scroll-btn testimonials-scroll-right"
            onClick={scrollRight}
            aria-label="Scroll testimonials right"
          >
            <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
              <path d="M8.59 16.59L10 18l6-6-6-6-1.41 1.41L13.17 12z" />
            </svg>
          </button>
        </div>
      </div>
    </section>
  );
};

// Simple LoadingBar component
const LoadingBar = () => (
  <div className="girukambakamchennai-loading-bar">
    <style jsx>{`
      @keyframes loading {
        0% {
          width: 0%;
        }
        50% {
          width: 50%;
        }
        100% {
          width: 100%;
        }
      }
    `}</style>
  </div>
);

// Your CORRECTED API Configuration
const API_CONFIG = {
  baseURL7001: "https://clinic-api.h-cura.com/",
  apiPath: "api/v1/",
  apiName: {
    apptFormFilling: "super_admin/patient/form/website",
    contactFormFilling: "super_admin/contact/us/form/website",
    offerFormFilling: "super_admin/appt/offer/form",
    corporateFormFilling: "super_admin/corporate/form/website",
    patientsCount: "super_admin/get/home/count",
  },
};

const Heart = ({ width = "100%", height = "100%" }) => (
  <svg width={width} height={height} fill="currentColor" viewBox="0 0 24 24">
    <path d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z" />
  </svg>
);

const Shield = () => (
  <svg className="w-8 h-8" fill="currentColor" viewBox="0 0 24 24">
    <path d="M12,1L3,5V11C3,16.55 6.84,21.74 12,23C17.16,21.74 21,16.55 21,11V5L12,1M12,7C13.4,7 14.8,8.6 14.8,10V11H16V18H8V11H9.2V10C9.2,8.6 10.6,7 12,7M12,8.2C11.2,8.2 10.4,8.7 10.4,10V11H13.6V10C13.6,8.7 12.8,8.2 12,8.2Z" />
  </svg>
);

const Video = () => (
  <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 24 24">
    <path d="M17,10.5V7A1,1 0 0,0 16,6H4A1,1 0 0,0 3,7V17A1,1 0 0,0 4,18H16A1,1 0 0,0 17,17V13.5L21,17.5V6.5L17,10.5Z" />
  </svg>
);

const Clock = () => (
  <svg className="w-8 h-8" fill="currentColor" viewBox="0 0 24 24">
    <path d="M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2M16.2,16.2L11,13V7H12.5V12.2L17,14.7L16.2,16.2Z" />
  </svg>
);

const Users = () => (
  <svg className="w-8 h-8" fill="currentColor" viewBox="0 0 24 24">
    <path d="M16 4C18.2 4 20 5.8 20 8S18.2 12 16 12 12 10.2 12 8 13.8 4 16 4M16 14C18.7 14 24 15.3 24 18V20H8V18C8 15.3 13.3 14 16 14M8 4C10.2 4 12 5.8 12 8S10.2 12 8 12 4 10.2 4 8 5.8 4 8 4M8 14C10.7 14 16 15.3 16 18V20H0V18C0 15.3 5.3 14 8 14Z" />
  </svg>
);


const Leaf = () => (
  <svg className="w-7 h-7" fill="currentColor" viewBox="0 0 24 24">
    <path d="M17,8C8,10 5.9,16.17 3.82,21.34L5.71,22L6.66,19.7C7.14,19.87 7.64,20 8,20C19,20 22,3 22,3C21,5 14,5.25 9,6.25C4,7.25 2,11.5 2,13.5C2,15.5 3.75,17.25 3.75,17.25C7,8 17,8 17,8Z" />
  </svg>
);

const Eye = () => (
  <svg className="w-7 h-7" fill="currentColor" viewBox="0 0 24 24">
    <path d="M12,9A3,3 0 0,0 9,12A3,3 0 0,0 12,15A3,3 0 0,0 15,12A3,3 0 0,0 12,9M12,17A5,5 0 0,1 7,12A5,5 0 0,1 12,7A5,5 0 0,1 17,12A5,5 0 0,1 12,17M12,4.5C7,4.5 2.73,7.61 1,12C2.73,16.39 7,19.5 12,19.5C17,19.5 21.27,16.39 23,12C21.27,7.61 17,4.5 12,4.5Z" />
  </svg>
);



const Stethoscope = () => (
  <svg className="w-7 h-7" fill="currentColor" viewBox="0 0 24 24">
    <path d="M19,8A3,3 0 0,0 16,11C16,12.88 15.27,14.54 14.05,15.72L13.41,14.41C14.21,13.5 14.7,12.3 14.7,11A3,3 0 0,0 11.7,8A3,3 0 0,0 8.7,11C8.7,12.3 9.19,13.5 10,14.41L9.34,15.72C8.12,14.54 7.4,12.88 7.4,11A4.3,4.3 0 0,1 11.7,6.7A4.3,4.3 0 0,1 16,11A3,3 0 0,0 19,8M11.7,1C8.26,1 5.44,3.8 5.4,7.24V11A7.29,7.29 0 0,0 12.7,18.3A7.29,7.29 0 0,0 19.95,11V7.24C19.91,3.8 17.09,1 13.65,1H11.7Z" />
  </svg>
);

const Calendar = () => (
  <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
    <path d="M19,3H18V1H16V3H8V1H6v2H5A2,2 0 0,0 3,5V19A2,2 0 0,0 5,21H19A2,2 0 0,0 21,19V5A2,2 0 0,0 19,3M19,19H5V8H19V19Z" />
  </svg>
);

const Phone = () => (
  <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
    <path d="M6.62,10.79C8.06,13.62 10.38,15.94 13.21,17.38L15.41,15.18C15.69,14.9 16.08,14.82 16.43,14.93C17.55,15.3 18.75,15.5 20,15.5A1,1 0 0,1 21,16.5V20A1,1 0 0,1 20,21A17,17 0 0,1 3,4A1,1 0 0,1 4,3H7.5A1,1 0 0,1 8.5,4C8.5,5.25 8.7,6.45 9.07,7.57C9.18,7.92 9.1,8.31 8.82,8.59L6.62,10.79Z" />
  </svg>
);





const Award = () => (
  <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 24 24">
    <path d="M5,16L3,5L8.5,12L12,5L15.5,12L21,5L19,16H5M12,8L10.5,11L12,14L13.5,11L12,8Z" />
  </svg>
);

const CheckCircle = () => (
  <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 24 24">
    <path d="M12 2C6.5 2 2 6.5 2 12S6.5 22 12 22 22 17.5 22 12 17.5 2 12 2M10 17L5 12L6.41 10.59L10 14.17L17.59 6.58L19 8L10 17Z" />
  </svg>
);

const ChevronRight = () => (
  <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 24 24">
    <path d="M8.59,16.58L13.17,12L8.59,7.41L10,6L16,12L10,18L8.59,16.58Z" />
  </svg>
);

const MapPin = () => (
  <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
    <path d="M12,11.5A2.5,2.5 0 0,1 9.5,9A2.5,2.5 0 0,1 12,6.5A2.5,2.5 0 0,1 14.5,9A2.5,2.5 0 0,1 12,11.5M12,2A7,7 0 0,0 5,9C5,14.25 12,22 12,22C12,22 19,14.25 19,9A7,7 0 0,0 12,2Z" />
  </svg>
);

const Mail = () => (
  <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
    <path d="M20,8L12,13L4,8V6L12,11L20,6M20,4H4C2.89,4 2,4.89 2,6V18A2,2 0 0,0 4,20H20A2,2 0 0,0 22,18V6C22,4.89 21.1,4 20,4Z" />
  </svg>
);

const Download = () => (
  <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
    <path d="M5,20H19V18H5M19,9H15V3H9V9H5L12,16L19,9Z" />
  </svg>
);

const ChevronDown = () => (
  <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 24 24">
    <path d="M7.41,8.58L12,13.17L16.59,8.58L18,10L12,16L6,10L7.41,8.58Z" />
  </svg>
);

const Tooth = () => (
  <svg className="w-7 h-7" fill="currentColor" viewBox="0 0 24 24">
    <path d="M12,2C9.8,2 8,3.8 8,6C8,7.1 8.4,8.1 9.1,8.8L9,9C9,11 9,13 9,15C9,17.2 10.8,19 13,19C15.2,19 17,17.2 17,15C17,13 17,11 17,9L16.9,8.8C17.6,8.1 18,7.1 18,6C18,3.8 16.2,2 14,2H12M12,4H14C15.1,4 16,4.9 16,6C16,7.1 15.1,8 14,8H12C10.9,8 10,7.1 10,6C10,4.9 10.9,4 12,4Z" />
  </svg>
);

const Pill = () => (
  <svg className="w-7 h-7" fill="currentColor" viewBox="0 0 24 24">
    <path d="M4.22,11.29L11.29,4.22C13.64,1.88 17.43,1.88 19.78,4.22C22.12,6.56 22.12,10.36 19.78,12.71L12.71,19.78C10.36,22.12 6.56,22.12 4.22,19.78C1.88,17.43 1.88,13.64 4.22,11.29M5.64,12.71C4.59,13.75 4.59,15.46 5.64,16.5C6.68,17.54 8.39,17.54 9.43,16.5L16.5,9.43C17.54,8.39 17.54,6.68 16.5,5.64C15.46,4.59 13.75,4.59 12.71,5.64L5.64,12.71M13.41,10.59L10.59,13.41L9.17,12L12,9.17L13.41,10.59Z" />
  </svg>
);

const HCuraHomepage = () => {
  const [activeTab, setActiveTab] = useState("hair");
  const [selectedModal, setSelectedModal] = useState(null);
  const [currentSlide, setCurrentSlide] = useState(0);
  const [expandedFAQ, setExpandedFAQ] = useState(null);
  const [currentBannerSlide, setCurrentBannerSlide] = useState(0);
  const [showSuccessMessage, setShowSuccessMessage] = useState(false);
  const [currentImageIndex, setCurrentImageIndex] = useState(0);

  const [treatmentsActiveTab, setTreatmentsActiveTab] = useState("All");

  // ==================== TIME-BASED CLINIC STATUS ====================
  // Function to check if clinic is open (10 AM - 8 PM)
  const isClinicOpen = () => {
    const now = new Date();
    const currentHour = now.getHours();
    const currentMinute = now.getMinutes();
    const currentTime = currentHour + currentMinute / 60;
    
    // Open from 10:00 AM (10.0) to 8:00 PM (20.0)
    // After 8:01 PM (20.016) until 9:59 AM (9.983) = Closed
    return currentTime >= 10 && currentTime < 20;
  };

  // State for clinic status
  const [clinicStatus, setClinicStatus] = useState(isClinicOpen() ? "Open" : "Close");

  // Update clinic status every minute
  useEffect(() => {
    const statusInterval = setInterval(() => {
      setClinicStatus(isClinicOpen() ? "Open" : "Close");
    }, 60000); // Check every minute

    return () => clearInterval(statusInterval);
  }, []);
  // ==================== END TIME-BASED CLINIC STATUS ====================

  const treatmentsData = {
    Hair: [
      { 
        name: "HAIR GFC", 
        image: hairFall,
        url: "/advanced-hair-gfc-treatment/"
      },
      { 
        name: "HAIR PRP", 
        image: thinning,
        url: "/advanced-hair-prp-treatment/"
      },
      { 
        name: "HAIR STM", 
        image: alopecia,
        url: "/advanced-stm-treatment/"
      },
      { 
        name: "GRO HAIR", 
        image: dandruff,
        url: "/advanced-grow-hair-treatment/"
      },
      { 
        name: "EXOS GFC", 
        image: exosomes,
      },
      { 
        name: "Qr678", 
        image: qr678,
      },
      { 
        name: "HAIR MESOTHERAPY", 
        image: meso,
      },
      { 
        name: "EXOSOME THERAPY", 
        image: exos,
      },
    ],

    Skin: [
      { 
        name: "FACE HYDRAFACIAL", 
        image: acne,
        url: "/advanced-hydrafacial-treatment/"
      },
      { 
        name: "FACE PRP", 
        image: pigmentation,
        url: "/advanced-prp-face-treatment"
      },
      { 
        name: "ANTI AGEING", 
        image: psoriasis,
        url: "/advanced-anti-ageing-treatment"
      },
      { 
        name: "FACE ACNE", 
        image: eczema,
        url: "/advanced-acne-treatment/"
      },
      { 
        name: "FACE GFC", 
        image: facegfc,
      },
      { 
        name: "FACE EXOSOMES", 
        image: faceexos,
      },
      { 
        name: "FACE CO2", 
        image: faceco2,
        url: "/advanced-co2-facial-treatment"
      },
      { 
        name: "FACE HAIR REMOVAL", 
        image: facehairremoval,
        url: "/advanced-laser-hair-removal-treatment"
      },
    ],

    Homeopathy: [
      { 
        name: "PCOD / PCOS", 
        image: pcod,
        url: "/homeopathy-best-treatments/pcod-pcos-treatment"
      },
      { 
        name: "INFERTILITY", 
        image: infertility,
        url: "/homeopathy-best-treatments/infertility-treatment"
      },
      { 
        name: "ASTHMA", 
        image: asthma,
        url: "/homeopathy-best-treatments/asthma-treatment"
      },
      { 
        name: "THYROID", 
        image: thyroid,
        url: "/homeopathy-best-treatments/thyroid-treatment"
      },
    ],

    Dental: [
      { 
        name: "Braces & Aligners", 
        image: braces,
        url: "/dental-treatment"
      },
      { 
        name: "Root Canal Treatment", 
        image: rootCanal,
        url: "/dental-treatment"
      },
      { 
        name: "Dental Implants", 
        image: dentalImplant,
        url: "/dental-treatment"
      },
      { 
        name: "PediatricDentistry", 
        image: teethWhitening,
        url: "/dental-treatment"
      },
    ],
  };

  const treatmentsCategories = ["All", "Hair", "Skin", "Homeopathy", "Dental"];
  const treatmentsCategoryLinks = {
    Hair: "/advanced-grow-hair-treatment",
    Skin: "/advanced-hydrafacial-treatment", 
    Homeopathy: "/homeopathy-best-treatments",
    Dental: "/dental-treatment",
  };

  const carouselTrackRef = useRef(null);

const goToSlide = (index) => {
  setCurrentImageIndex(index);
  if (carouselTrackRef.current) {
    carouselTrackRef.current.style.transform = `translateX(-${index * 20}%)`;
  }
};

const goToNext = () => {
  const nextIndex = (currentImageIndex + 1) % 5;
  goToSlide(nextIndex);
};

const goToPrevious = () => {
  const prevIndex = currentImageIndex === 0 ? 4 : currentImageIndex - 1;
  goToSlide(prevIndex);
};

  const [selectedLocation, setSelectedLocation] = useState("chennai");
  const [showLocationDetails, setShowLocationDetails] = useState(false);

  useEffect(() => {
    document.title =
      "H-Cura Multispeciality Clinic | India's Leading Hair, Skin, Dental & Homeopathy Center";
    const metaDescription = document.querySelector("meta[name='description']");
    if (metaDescription) {
      metaDescription.setAttribute(
        "content",
        "hcura Multispeciality, India's first online and offline multispeciality clinic. Offering expert care in Bangalore, Chennai, and online consultations worldwide, we provide holistic treatment for skin, hair, chronic diseases, and more. Book an appointment today at H-Cura!. Meet our expert doctors dedicated to personalized care and natural healing."
      );
    }
    const metaKeywords = document.querySelector("meta[name='keywords']");
    if (metaKeywords) {
      metaKeywords.setAttribute(
        "content",
        "H-Cura Homeopathy,Homeopathy clinic in Chennai,Multispecialty clinic in Chennai,Natural healing solutions,Holistic health treatments,Personalized homeopathy care,Homeopathy for wellness,Online homeopathy consultation,Trusted homeopathy clinic,Leading homeopathy treatment center,Expert homeopaths in Chennai,Affordable homeopathic care,Homeopathy for health and wellness,Multidisciplinary healthcare approach."
      );
    }
    const existingCanonical = document.querySelector("link[rel='canonical']");
    if (existingCanonical) {
      existingCanonical.setAttribute("href", "https://www.h-cura.com/");
    } else {
      const canonicalLink = document.createElement("link");
      canonicalLink.setAttribute("rel", "canonical");
      canonicalLink.setAttribute("href", "https://www.h-cura.com/");
      document.head.appendChild(canonicalLink);
    }
  }, []);

  const INITIAL_FORM_DATA = {
    name: "",
    age: "",
    phoneNo: "",
    state: "",
    message: "",
    consultationType: "",
    concern: "",
    branch: "",
  };

  const BRANCH_OPTIONS = [
    { value: "JAYANAGAR, BANGALORE", label: "JAYANAGAR, BANGALORE" },
    { value: "VALSARAVAKAM, CHENNAI", label: "VALSARAVAKAM, CHENNAI" },
    { value: "MADHANATHAPURAM, CHENNAI", label: "MADHANATHAPURAM, CHENNAI" },
  ];

  const [formData, setFormData] = useState(INITIAL_FORM_DATA);
  const [errors, setErrors] = useState({});
  const [showBranches, setShowBranches] = useState(false);
  const [loading, setLoading] = useState(false);

  const bounce = cssTransition({
    enter: "bounceIn",
    exit: "bounceOut",
    duration: [600, 300],
  });

  const handleLocationClick = (location) => {
    setSelectedLocation(location);
    if (window.innerWidth <= 768) {
      setShowLocationDetails(true);
    }
  };

  useEffect(() => {
    const updateLocationDisplay = () => {
      if (window.innerWidth > 768) {
        setShowLocationDetails(true);
      } else {
        setShowLocationDetails(false);
      }
    };

    updateLocationDisplay();
    window.addEventListener("resize", updateLocationDisplay);

    return () => window.removeEventListener("resize", updateLocationDisplay);
  }, []);

  const bannerSlides = [
    {
      title: "Advanced Hair Treatments",
      subtitle: "Regain Your Confidence",
      description:
        "Advanced aesthetic treatments constisting GFC, PRP and Stem Cell therapy for natural hair regrowth and thickening with maximum possible success rate.",
      icon: <Leaf />,
      cta: "Book Consultation",
      bgImage: banner1, 
      link: "/advanced-grow-hair-treatment",
    },

    {
      title: "Advanced Skin Treatments",
      subtitle: "Healthy and glowing Skin",
      description:
        "Holistic skin cosmetology services featuring PRP Face, CO₂ Facial, Acne control, and Anti-Aging treatments tailored to your skin requirements.",
      icon: <Eye />,
      cta: "Book Consultation",
      bgImage: banner2, 
      link: "/advanced-hydrafacial-treatment",
    },

    {
      title: "Offline Homeopathy",
      subtitle: "Nature's Healing Power",
      description:
        "Classical homeopathic care for both acute and chronic conditions, focused on overall wellness and patient satisfaction.",
      icon: <Pill />,
      cta: "Book Consultation",
      bgImage: banner3, 
      link: "/homeopathy-best-treatments/",
    },
    {
      title: "Complete Dental Care",
      subtitle: "Your Smile Matters",
      description:
        " Advanced dental care using modern dentistry to ensure optimal oral health.",
      icon: <Tooth />,
      cta: "Book Consultation",
      bgImage: banner4, 
      link: "/dental-treatment/",
    },
    {
      title: "Online Homeopathy ",
      subtitle: "Natural Healing at Home",
      description:
        "Connect with qualified homeopathic doctors online and receive personalized, natural treatments. Safe, gentle, and effective remedies for all ages, delivered to your doorstep.",
      icon: <Leaf />,
      cta: "Book Consultation",
      bgImage: banner5, 
      link: "/homeopathy-online-consultation/",
    },
    {
      title: "Specialist consultation",
      subtitle: "Personalized Care",
      description:
        "Consult qualified doctors in aesthetics, dental, and homeopathy care available both online and offline.",
      icon: <Stethoscope />,
      cta: "Book Consultation",
      bgImage: banner6, 
      link: "/doctors-list/",
    },
  ];

  useEffect(() => {
    const panel = document.querySelector(".hcura-content-panel");
    if (panel && showLocationDetails) {
      panel.style.opacity = "0";
      panel.style.transform = "translateY(20px)";

      setTimeout(() => {
        panel.style.opacity = "1";
        panel.style.transform = "translateY(0)";
        panel.style.transition = "all 0.4s ease";

        if (
          window.innerWidth <= 768 &&
          selectedLocation &&
          showLocationDetails
        ) {
          panel.scrollIntoView({
            behavior: "smooth",
            block: "start",
            inline: "nearest",
          });
        }
      }, 100);
    }
  }, [selectedLocation, showLocationDetails]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
    setErrors((prev) => ({ ...prev, [name]: "" }));
  };

  const validateForm = () => {
    const newErrors = {};

    if (!formData.name.trim()) newErrors.name = "Name is required";

    if (!formData.phoneNo) {
      newErrors.phoneNo = "Phone number is required.";
    } else if (!/^[0-9]+$/.test(formData.phoneNo)) {
      newErrors.phoneNo = "Phone number can only contain numbers.";
    } else if (formData.phoneNo.length !== 10) {
      newErrors.phoneNo = "Phone number must be exactly 10 digits.";
    }

    if (!formData.concern.trim()) newErrors.concern = "Please select a concern";
    if (!formData.consultationType)
      newErrors.consultationType = "Please select a consultation type";

    if (formData.consultationType === "offline" && !formData.branch)
      newErrors.branch = "Please select a branch";

    return newErrors;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const validationErrors = validateForm();
    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      return;
    }

    setLoading(true);

    try {
      console.log("Submitting form data:", formData);

      const response = await axios.post(
        `${API_CONFIG.baseURL7001}${API_CONFIG.apiPath}${API_CONFIG.apiName.apptFormFilling}`,
        formData,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      console.log("API Response:", response);

      if (response.status >= 200 && response.status < 300) {
        setShowSuccessMessage(true);
        setFormData(INITIAL_FORM_DATA);
        setShowBranches(false);
        setErrors({});

        if (window.innerWidth <= 768) {
          const formElement = document.querySelector(
            ".girukambakamchennai-contact-form"
          );
          if (formElement) {
            formElement.scrollIntoView({ behavior: "smooth", block: "center" });
          }
        }
      } else {
        console.error(
          "API Error (Non-2xx status):",
          response.status,
          response.data
        );
        toast.error(
          `Form submission failed: ${
            response.data.message || "Server responded with an error."
          }`,
          {
            position: "top-center",
            transition: bounce,
            autoClose: 3000,
          }
        );
      }
    } catch (error) {
      console.error("Submission error:", error);
      if (error.response) {
        console.error("Error response data:", error.response.data);
        console.error("Error response status:", error.response.status);
        console.error("Error response headers:", error.response.headers);
        toast.error(
          `Error: \${
            error.response.data.message || "Server responded with an error."
          }`,
          {
            position: "top-center",
            transition: bounce,
            autoClose: 3000,
          }
        );
      } else if (error.request) {
        console.error("No response received from API:", error.request);
        toast.error(
          "Network error: No response from server. Please check your internet connection.",
          {
            position: "top-center",
            transition: bounce,
            autoClose: 3000,
          }
        );
      } else {
        console.error("Error setting up request:", error.message);
        toast.error(
          "An unexpected error occurred. Please try again or contact us.",
          {
            position: "top-center",
            transition: bounce,
            autoClose: 3000,
          }
        );
      }
    } finally {
      setLoading(false);
    }
  };

  const handleConsultationTypeChange = (e) => {
    const { value } = e.target;
    setFormData((prev) => ({
      ...prev,
      consultationType: value,
      branch: value === "offline" ? "" : prev.branch,
    }));
    setShowBranches(value === "offline");
  };

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentBannerSlide((prev) => (prev + 1) % bannerSlides.length);
    }, 10000);
    return () => clearInterval(interval);
  }, [bannerSlides.length]);

  
   const beforeAfterData = {
    hair: [
      {
        id: "hair-1",
        combined: img1,
        testimonial: {
          quote: "My hair has never looked better!",
        },
      },
      {
        id: "hair-2",
        combined: img2,
        testimonial: {
          quote: "Incredible results, highly recommend!",
        },
      },
      {
        id: "hair-3",
        combined: img3,
        testimonial: {
          quote: "I feel so much more confident now.",
        },
      },
      {
        id: "hair-4",
        combined: img4,
        testimonial: {
          quote: "The best decision I made for my hair.",
        },
      },
      {
        id: "hair-5",
        combined: img5,
        testimonial: {
          quote: "Natural and effective treatment.",
        },
      },
      {
        id: "hair-6",
        combined: img6,
        testimonial: {
          quote: "Visible changes in just a few months.",
        },
      },
      {
        id: "hair-7",
        combined: img7,
        testimonial: {
          quote: "Fantastic care and amazing outcome.",
        },
      },
      {
        id: "hair-8",
        combined: img8,
        testimonial: {
          quote: "Truly life-changing results.",
        },
      },
      {
        id: "hair-9",
        combined: img9,
        testimonial: {
          quote: "My hair feels so much stronger and healthier.",
        },
      },
      {
        id: "hair-10",
        combined: img10,
        testimonial: {
          quote: "Finally, the volume I always wanted!",
        },
      },
    ],
    skin: [
      {
        id: "skin-1",
        combined: img11,
        testimonial: {
          quote: "My skin is so clear and radiant now!",
        },
      },
      {
        id: "skin-2",
        combined: img12,
        
        testimonial: {
          quote: "No more breakouts, thank you H-Cura!",
          author: "Satisfied Skin Patient L",
        },
      },
      {
        id: "skin-3",
        combined: img13,
        testimonial: {
          quote: "I love my new glowing skin.",
        },
      },
      {
        id: "skin-4",
        combined: img14,
        testimonial: {
          quote: "My wrinkles have visibly reduced.",
        },
      },
      {
        id: "skin-5",
        combined: img15,
        testimonial: {
          quote: "My skin feels incredibly smooth.",
        },
      },
      {
        id: "skin-6",
        combined: img16,
        testimonial: {
          quote: "My skin looks years younger.",
        },
      },
      {
        id: "skin-7",
        combined: img17,
        testimonial: {
          quote: "My complexion is so much more even now.",
        },
      },
      {
        id: "skin-8",
        combined: img18,
        testimonial: {
          quote: "My skin feels perfectly hydrated.",
        },
      },
      {
        id: "skin-9",
        combined: img19,
        testimonial: {
          quote: "The dark spots are almost gone!",
        },
      },
      {
        id: "skin-10",
        combined: img20,
        testimonial: {
          quote: "My skin truly glows from within.",
        },
      },
    ],
  };



  const openModal = (category) => {
    setSelectedModal(category);
    setCurrentSlide(0);
  };

  const closeModal = () => {
    setSelectedModal(null);
    setCurrentSlide(0);
  };

  const nextSlide = () => {
    const data = beforeAfterData[selectedModal] || [];
    setCurrentSlide((prev) => (prev + 1) % data.length);
  };

  const prevSlide = () => {
    const data = beforeAfterData[selectedModal] || [];
    setCurrentSlide((prev) => (prev - 1 + data.length) % data.length);
  };

  const toggleFAQ = (index) => {
    setExpandedFAQ(expandedFAQ === index ? null : index);
  };

const faqData = [
  // Existing FAQs here...

  {
    question: "How effective is GFC treatment for hair regrowth?",
    answer:
      "GFC (Growth Factor Concentrate) is a highly advanced hair regrowth treatment that uses your own growth factors to stimulate hair follicles. It helps reduce hair fall, increase hair thickness, and improve hair density. Visible results are usually seen within 6–12 weeks with 4–6 sessions recommended.",
  },
  {
    question: "What are the benefits of PRP for face rejuvenation?",
    answer:
      "PRP (Platelet Rich Plasma) for the face boosts collagen production, reduces wrinkles, lightens dark circles, treats acne scars, and improves overall skin texture. It uses your own platelets, making it natural, safe, and highly effective for anti-aging and skin repair.",
  },
  {
    question: "Are there any side effects of homeopathic medicines?",
    answer:
      "Homeopathic medicines are completely safe and have no side effects when prescribed by qualified doctors. They are natural, non-toxic, and suitable for all age groups including children and pregnant women.",
  },
  {
    question: "How effective are braces and aligners for teeth straightening?",
    answer:
      "Braces and aligners effectively correct crooked teeth, gaps, bite issues, and jaw alignment problems. Aligners are invisible and removable, while braces provide strong and precise movement. Treatment duration varies from 6–24 months depending on the severity of the case.",
  },
  {
  question: "How does online homeopathy consultation work?",
  answer:
    "Online homeopathy consultation is done through secure video calls with qualified doctors. Your symptoms, case history, lifestyle, and medical reports are studied in detail. Based on this, a personalized treatment plan and medicines are prescribed, which are then delivered to your doorstep. Regular follow-ups are provided for tracking progress and adjusting the treatment if needed.",
},

];


  useEffect(() => {
    const interval = setInterval(() => {
      setActiveTab((prevTab) => (prevTab === "hair" ? "skin" : "hair"));
    }, 9000);

    return () => clearInterval(interval);
  }, []);

 
     return (
    <div className="girukambakamchennai-hcura-chennai">
      <section className="girukambakamchennai-floating-banner">
        <div className="girukambakamchennai-banner-wrapper">
          {bannerSlides.map((slide, index) => {
            const formatTitle = (title, slideIndex) => {
              if (window.innerWidth <= 768) {
                if (slideIndex === 1) {
                  return title.replace(
                    "Skin Treatments",
                    "Skin<br/>Treatments"
                  );
                }
                if (slideIndex === 3) {
                  return title.replace("Dental Care", "Dental<br/>Care");
                }
              }
              return title;
            };

            return (
              <div
                key={index}
                className={`girukambakamchennai-banner-slide-enhanced ${
                  index === currentBannerSlide ? "active" : ""
                }`}
                style={{
                  backgroundImage: slide.bgImage
                    ? `url(${slide.bgImage})`
                    : "none",
                  backgroundColor: slide.bgImage ? "transparent" : "#ff0000",
                }}
              >
                <div className="girukambakamchennai-banner-content-enhanced">
                  <div className="girukambakamchennai-banner-text-animated">
                    <h1
                      className="girukambakamchennai-banner-title-main"
                      dangerouslySetInnerHTML={{
                        __html: `<a href="${slide.link}">${formatTitle(
                          slide.title,
                          index
                        )}</a>`,
                      }}
                    />
                    <h2 className="girukambakamchennai-banner-subtitle-main">
                      {slide.subtitle}
                    </h2>
                    <p className="girukambakamchennai-banner-description-main">
                      {slide.description}
                    </p>
                    <div className="girukambakamchennai-banner-actions">
                      <a
                        href={slide.link}
                        className="girukambakamchennai-banner-cta-primary"
                      >
                        {slide.cta}
                      </a>
                      <a
                        href="tel:9964688333"
                        className="girukambakamchennai-banner-cta-secondary"
                      >
                        <MdPhone />
                        +91-99646 88333
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            );
          })}
        </div>

        <div className="girukambakamchennai-banner-dots">
          {bannerSlides.map((_, index) => (
            <button
              key={index}
              className={`girukambakamchennai-banner-dot ${
                index === currentBannerSlide ? "active" : ""
              }`}
              onClick={() => setCurrentBannerSlide(index)}
              aria-label={`Go to slide ${index + 1}`}
            />
          ))}
        </div>
      </section>

      {/* REST OF YOUR CODE CONTINUES HERE - Counter Section, About Section, etc. */}


      {/* Counter Section - Continues in next part */}
            <section className="counter-container">
      <div className="girukambakamchennai-section-header">
        <span className="hcura-subtitle">Proven Results </span>
        <h2 className="girukambakamchennai-section-title">
          Evidence{" "}
          <span className="girukambakamchennai-gradient-text">
            of Excellence
          </span>
        </h2>
        <p className="girukambakamchennai-section-description">
Trusted by thousands of patients, our advanced healthcare solutions deliver measurable and lasting transformation. Through modern technology, proven therapies, and compassionate care, we create long-term transformations.        </p>
      </div>

      <div className="treatment-counters-wrapper">
        <div className="treatment-counters">
          <div className="treatment-category">
            <div className="treatment-header">
              Hair Treatment -{" "}
              <span className="header-count" data-header-count="15000">
                15000
              </span>
              +
            </div>
            <div className="treatment-items">
              <div className="treatment-item">
                <div className="treatment-name">Premium GFC</div>
                <div className="treatment-count" data-count="2500">
                  2500+
                </div>
              </div>
              <div className="treatment-item">
                <div className="treatment-name">Advance GFC</div>
                <div className="treatment-count" data-count="5000">
                  5000+
                </div>
              </div>
              <div className="treatment-item">
                <div className="treatment-name">PRP</div>
                <div className="treatment-count" data-count="3500">
                  3500+
                </div>
              </div>
              <div className="treatment-item">
                <div className="treatment-name">QR678</div>
                <div className="treatment-count" data-count="1500">
                  1500+
                </div>
              </div>
              <div className="treatment-item">
                <div className="treatment-name">Exo GFC</div>
                <div className="treatment-count" data-count="1000">
                  1000+
                </div>
              </div>
              <div className="treatment-item">
                <div className="treatment-name">STM</div>
                <div className="treatment-count" data-count="1500">
                  1500+
                </div>
              </div>
            </div>
          </div>

          <div className="treatment-category">
            <div className="treatment-header">
              Skin Treatment -{" "}
              <span className="header-count" data-header-count="10500">
                10500
              </span>
              +
            </div>
            <div className="treatment-items">
              <div className="treatment-item">
                <div className="treatment-name">HydraFacial</div>
                <div className="treatment-count" data-count="3500">
                  3500+
                </div>
              </div>
              <div className="treatment-item">
                <div className="treatment-name">Acne</div>
                <div className="treatment-count" data-count="2000">
                  2000+
                </div>
              </div>
              <div className="treatment-item">
                <div className="treatment-name">Anti-Aging</div>
                <div className="treatment-count" data-count="1500">
                  1500+
                </div>
              </div>
              <div className="treatment-item">
                <div className="treatment-name">Skin Whitening</div>
                <div className="treatment-count" data-count="1500">
                  1500+
                </div>
              </div>
              <div className="treatment-item">
                <div className="treatment-name">Glutathione</div>
                <div className="treatment-count" data-count="1000">
                  1000+
                </div>
              </div>
              <div className="treatment-item">
                <div className="treatment-name">Co2 Facial</div>
                <div className="treatment-count" data-count="1000">
                  1000+
                </div>
              </div>
            </div>
          </div>

          <div className="treatment-category">
            <div className="treatment-header">
              Dental Treatment -{" "}
              <span className="header-count" data-header-count="3700">
                5100
              </span>
              +
            </div>
            <div className="treatment-items">
              <div className="treatment-item">
                <div className="treatment-name"> Consultation</div>
                <div className="treatment-count" data-count="1500">
                  1500+
                </div>
              </div>
              <div className="treatment-item">
                <div className="treatment-name">Scaling</div>
                <div className="treatment-count" data-count="1000">
                  2000+
                </div>
              </div>
              <div className="treatment-item">
                <div className="treatment-name">Filling</div>
                <div className="treatment-count" data-count="750">
                  750+
                </div>
              </div>
              <div className="treatment-item">
                <div className="treatment-name">RCT</div>
                <div className="treatment-count" data-count="250">
                  250+
                </div>
              </div>
              <div className="treatment-item">
                <div className="treatment-name">ortho Braces</div>
                <div className="treatment-count" data-count="100">
                  500+
                </div>
              </div>
              <div className="treatment-item">
                <div className="treatment-name">Teeth Whitening</div>
                <div className="treatment-count" data-count="100">
                  100+
                </div>
              </div>
            </div>
          </div>

          <div className="treatment-category">
            <div className="treatment-header">
              Homeopathy Treatment -{" "}
              <span className="header-count" data-header-count="26000">
                26000
              </span>
              +
            </div>
            <div className="treatment-items">
              <div className="treatment-item">
                <div className="treatment-name">Online</div>
                <div className="treatment-count" data-count="15000">
                  15000+
                </div>
              </div>
              <div className="treatment-item">
                <div className="treatment-name">Offline</div>
                <div className="treatment-count" data-count="5000">
                  5000+
                </div>
              </div>
              <div className="treatment-item">
                <div className="treatment-name">PCOD</div>
                <div className="treatment-count" data-count="1500">
                  1500+
                </div>
              </div>
              <div className="treatment-item">
                <div className="treatment-name">PCOS</div>
                <div className="treatment-count" data-count="1000">
                  1000+
                </div>
              </div>
              <div className="treatment-item">
                <div className="treatment-name">Infertility</div>
                <div className="treatment-count" data-count="1500">
                  1500+
                </div>
              </div>
              <div className="treatment-item">
                <div className="treatment-name">Piles</div>
                <div className="treatment-count" data-count="2000">
                  2000+
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

      <section className="hcura-about-section">
        <div className="hcura-container">
          <div className="hcura-header">
            <span className="hcura-subtitle">Welcome to H-Cura</span>
            <h2 className="hcura-title">
              India's First Offline & Online{" "}
              <span className="hcura-gradient-text">
                MultiSpeciality Clinic
              </span>
            </h2>
            <p className="hcura-description">
             Welcome to H-Cura Multispecialty Clinic — a complete destination for effective and trustworthy healthcare.
We offer a full range of services under one roof, including homeopathy, advanced skin and hair solutions, and comprehensive dental care.

Our team of qualified doctors and specialists combines modern technology with proven natural methods to deliver treatments tailored to your needs.
Whether you’re looking for gentle homeopathic care, anti-aging and aesthetic solutions, hair restoration, or high-quality dental treatments, H-Cura provides expert care designed to help you look and feel your best.

Book your appointment today and experience healthcare that’s easier, personalized, and results-driven at H-Cura Multispecialty Clinic.
            </p>
          </div>

          <div className="hcura-content-grid">
            <div className="hcura-stats-container">
              <div className="hcura-stats-grid">
                <div className="hcura-stat-card">
                  <div className="hcura-stat-icon">
                    <Users />
                  </div>
                  <div className="hcura-stat-content">
                    <h3>50,000+</h3>
                    <p>Happy Patients</p>
                  </div>
                </div>
                <div className="hcura-stat-card">
                  <div className="hcura-stat-icon">
                    <Stethoscope />
                  </div>
                  <div className="hcura-stat-content">
                    <h3>100+</h3>
                    <p>Expert Doctors</p>
                  </div>
                </div>
                <div className="hcura-stat-card">
                  <div className="hcura-stat-icon">
                    <Award />
                  </div>
                  <div className="hcura-stat-content">
                    <h3>4.8★</h3>
                    <p>Google Rating</p>
                  </div>
                </div>
                <div className="hcura-stat-card">
                  <div className="hcura-stat-icon">
                    <Shield />
                  </div>
                  <div className="hcura-stat-content">
                    <h3>10</h3>
                    <p>Clinic Branches</p>
                  </div>
                </div>
              </div>
            </div>
            <div className="hcura-image-container">
              <div className="hcura-image-carousel">
                <div className="hcura-carousel-track" ref={carouselTrackRef}>
                  <img src={bannerjayanagar} alt="H-Cura Clinic Interior 1" />
                  <img src={bannervalasaravakkam} alt="H-Cura Clinic Interior 2" />
                  <img src={bannervalasaravakkam1} alt="H-Cura Clinic Interior 3" />
                  <img src={gerukambakkminterior} alt="H-Cura Clinic Interior 4" />
                  <img src={tambaraminterior} alt="H-Cura Clinic Interior 5" />
                </div>

                <button
                  className="hcura-carousel-btn hcura-carousel-prev"
                  onClick={goToPrevious}
                  aria-label="Previous image"
                >
                  <ChevronLeft />
                </button>
                <button
                  className="hcura-carousel-btn hcura-carousel-next"
                  onClick={goToNext}
                  aria-label="Next image"
                >
                  <ChevronRight />
                </button>

                <div className="hcura-carousel-dots">
                  {[0, 1, 2, 3, 4].map((index) => (
                    <button
                      key={index}
                      className={`hcura-carousel-dot \${
                        currentImageIndex === index ? "active" : ""
                      }`}
                      onClick={() => goToSlide(index)}
                      aria-label={`Go to image \${index + 1}`}
                    />
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

   <section className="girukambakamchennai-healthcare-services">
  <div className="girukambakamchennai-main-container">
    <div className="girukambakamchennai-header-section">
      <span className="girukambakamchennai-header-subtitle">
        What We Do Best
      </span>
      <h2 className="girukambakamchennai-header-title">
        Comprehensive{" "}
        <span className="girukambakamchennai-highlight-text">
           Healthcare Services
        </span>
      </h2>
      <p className="girukambakamchennai-header-description">
        From advanced hair and skincare to dental treatments and homeopathy, our qualified doctors offer customized care for every health requirement.
      </p>
    </div>

    <div className="girukambakamchennai-care-grid">
      {[
        {
          icon: Leaf,
          title: "Advanced Hair Care",
          description:
            "Proven treatments for hair loss, thinning hair, dandruff, and scalp problems using safe treatments",
          treatments: [
            "Hair Loss Treatment",
            "Dandruff Treatment",
            "PRP Therapy",
            "Scalp Treatment",
          ],
          image: hair,
          link: "/advanced-grow-hair-treatment",
        },
        {
          icon: Eye,
          title: "Advanced Skin Care",
          description:
            "Effective skincare solutions for acne, dark spots, wrinkles, and a wide range of skin concerns.",
          treatments: [
            "Pimple Treatment",
            "Anti-Aging",
            "Dark Spot Removal",
            "Skin Glow Treatment",
          ],
          image: homeskin,
          link: "/advanced-hydrafacial-treatment",
        },
        {
          icon: Pill,
          title: "Advanced Homeocare",
          description:
            "Holistic classical homeopathy that treats various health issues while enhancing your overall wellbeing.",
          treatments: [
            "Infertility",
            "Piles",
            "Women's Health",
            "Pcod/Pcos",
            "Skin Psoriasis",
            "Migraine",
          ],
          image: homehomeopathy,
          link: "/homeopathy-best-treatments",
        },
        {
          icon: Tooth,
          title: "Advanced Dental Care",
          description:
            "Comprehensive dental treatments using cutting-edge technology and patient-friendly care.",
          treatments: [
            "Teeth Whitening",
            "Root Canal",
            "Dental Implants",
            "Braces & Alignment",
          ],
          image: homedental,
          link: "/dental-treatment",
        },
      ].map((service, index) => (
        <div key={index} className="girukambakamchennai-care-card">
          <div className="girukambakamchennai-care-image">
            <img src={service.image} alt={service.title} />
            <div className="girukambakamchennai-care-overlay">
              <div className="girukambakamchennai-care-icon">
                <service.icon />
              </div>
            </div>
          </div>
          <div className="girukambakamchennai-care-content">
            <h3>{service.title}</h3>
            <p>{service.description}</p>
            <div className="girukambakamchennai-care-stats">
            </div>
            <div className="girukambakamchennai-treatment-badges">
              {service.treatments.map((treatment, idx) => (
                <span
                  key={idx}
                  className="girukambakamchennai-treatment-badge"
                >
                  {treatment}
                </span>
              ))}
            </div>
            <Link
              to={service.link}
              className="girukambakamchennai-care-button"
            >
              Read more
              <ChevronRight />
            </Link>
          </div>
        </div>
      ))}
    </div>
  </div>
</section>



      {/* New Treatments Section */}
<section className="hcura-theme-section">
  <div className="bubble"></div>
  <div className="bubble"></div>
  <div className="bubble"></div>
  <div className="bubble"></div>
  <div className="bubble"></div>
  <div className="bubble"></div>
  <div className="bubble"></div>
  <div className="bubble"></div>
  <div className="bubble"></div>
  <div className="bubble"></div>
  <div className="bubble"></div>
  <div className="bubble"></div>
  <div className="bubble"></div>
  <div className="bubble"></div>
  <div className="bubble"></div>
  
  <div className="hcura-theme-container">
    <div className="hcura-theme-header">
      <span className="hcura-theme-subtitle">Treatments We Offer</span>
         <h2 className="girukambakamchennai-header-title">
        H-Cura: Professional healthcare  {" "}
        <span className="girukambakamchennai-highlight-text">
         backed by clinical expertise.
        </span>
      </h2>
      <p className="hcura-theme-description">
        

        Experience complete <strong>Hair</strong>, <strong>Skin</strong>,  <strong>Homeopathy</strong>, and <strong>Dental</strong> solutions that help rejuvenate and restore your health in effective way.
      </p>
    </div>

    {/* Tabs */}
   <div className="hcura-theme-tabs">
      {treatmentsCategories.map((cat) => (
        <button
          key={cat}
          className={`hcura-theme-tab-btn \${
            treatmentsActiveTab === cat ? "active" : ""
          }`}
          onClick={() => setTreatmentsActiveTab(cat)}
        >
          {cat === "All" ? "All Services" : `Advanced ${cat}`}
        </button>
      ))}
    </div>


    {/* Treatments */}
    <div className="hcura-theme-treatments fade-in">
      {treatmentsActiveTab === "All" ? (
        <>
          {Object.keys(treatmentsData).map((category) => (
            <div
              key={category}
              className={`hcura-theme-category ${category.toLowerCase()}`}
            >
              <h3 className="hcura-theme-category-title">
               Advanced {category} 
              </h3>
              <div className="hcura-theme-grid">
                {treatmentsData[category].map((item, index) => (
                  <div key={index} className="hcura-theme-card">
                    <div className="hcura-theme-img-wrap">
                      <img src={item.image} alt={item.name} />
                    </div>
                    <div className="hcura-theme-card-body">
                      <h4>{item.name}</h4>
                      <Link to={item.url} className="hcura-theme-learn-btn">
                        Learn More <ChevronRight />
                      </Link>
                    </div>
                  </div>
                ))}
              </div>

              <div className="hcura-theme-viewall">
                <Link
                  to={treatmentsCategoryLinks[category]}
                  className="hcura-theme-viewall-btn"
                >
                  View All {category} Treatments <ChevronRight />
                </Link>
              </div>
            </div>
          ))}
        </>
      ) : (
        <div className="hcura-theme-grid fade-in">
          {treatmentsData[treatmentsActiveTab].map((item, index) => (
            <div key={index} className="hcura-theme-card">
              <div className="hcura-theme-img-wrap">
                <img src={item.image} alt={item.name} />
              </div>
              <div className="hcura-theme-card-body">
                <h4>{item.name}</h4>
                <Link to={item.url} className="hcura-theme-learn-btn">
                  Learn More <ChevronRight />
                </Link>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  </div>
</section>

      {/* Doctors Section - Continues */}
      <section className="doctors-showcase-optimized">
  <div className="showcase-wrapper-optimized">
    <div className="section-header-optimized">
      <span className="header-tag-optimized">Our Expert Team</span>
      <h2 className="main-title-optimized">
        Meet the Experts{" "}
        <span className="gradient-text-optimized">
           Behind Your Care
        </span>
      </h2>
      <p className="section-subtitle-optimized">
       Highly qualified specialists with extensive clinical expertise across multiple disciplines, committed to outcome-focused patient care.
      </p>
    </div>

    <div className="doctors-desktop-optimized">
      <div className="doctors-container-desktop-optimized">
        {[
          {
            name: "Dr.VEENA M",
            specialty: "Hair & Skin Specialist",
            image: veenadoc,
            expertise: ["BHMS,FMC | Exp. 4+ years"],
            experience: "4+ years",
            patients: "2500+",
            link: "/doctors/dr-veena-m-homeopathy-aesthetics-bangalore",
          },
          {
            name: "Dr.CHAYANIKA ",
            specialty: "Dental Specialist",
            image: Chayanika,
            expertise: ["BDS | Exp. 4+ years"],
            experience: "4+ years",
            patients: "1800+",
            link: "/doctors/dr-chayanika-ghosh-dentist-jayanagar-bangalore",
          },
          {
            name: "Dr. SPOORTHI PRASAD",
            specialty: "Homeopathy Specialist",
            image: spoorthi,
            expertise: ["BHMS | Exp. 8+ years"],
            experience: "8+ years",
            patients: "3200+",
            link: "/doctors/dr-spoorthi-prasad-senior-homeopathy-doctor-jayanagar-bangalore",
          },
          {
            name: "Dr. YUVAPRIYA",
            specialty: "Aesthetic Specialist | Dental Specialist",
            image: yuvapriya,
            expertise: ["BDS,FMC | Exp. 2+ years"],
            experience: "2+ years",
            patients: "1900+",
            link: "/doctors/dr-yuvapriya-p-dentist-aesthetic-jayanagar-bangalore",
          },
          {
            name: "Dr. PARGAVI J",
            specialty: "Aesthetic Specialist | Homeopathy Specialist",
            image: pargavi,
            expertise: ["BHMS, FFAC | Exp. 2+ years"],
            experience: "2+ years",
            patients: "1900+",
            link: "/doctors/dr-j-pargavi-homeopathy-aesthetic-doctor-jayanagar-bangalore",
          },
          {
            name: "Dr. PAVITHRA ",
            specialty: "Homeopathy Specialist",
            image: pavithra,
            expertise: ["BHMS | Exp. 1+ years"],
            experience: "1+ years",
            patients: "2100+",
            link: "/doctors/dr-pavithrakamatchi-jayanagar-bangalore",
          },
          {
            name: "Dr. MUTHUMARI",
            specialty: "Aesthetic Specialist | Homeopathy Specialist",
            image: muthumari,
            expertise: ["BHMS , FFACC | Exp. 1+ years"],
            experience: "1+ years",
            patients: "1900+",
            link: "/doctors/dr-muthumari-homeopathy-facial-aesthetics-valasaravakkam-chennai",
          },
          {
            name: "Dr. AHILAN MURUGADAS",
            specialty: "Aesthetic Specialist | Homeopathy Specialist",
            image: ahilan,
            expertise: ["BHMS , FMC , PGDDN | Exp. 4+ years"],
            experience: "4+ years",
            patients: "1900+",
            link: "/doctors/dr-ahilan-murugadas-homeopathy-cosmetic-nutrition-gerugambakkam-chennai",
          },
          {
            name: "Dr. ASHWINI",
            specialty: "Aesthetic Specialist | Homeopathy Specialist",
            image: aswini,
            expertise: ["BHMS | Exp. 4+ years"],
            experience: "4+ years",
            patients: "1900+",
            link: "/doctors/dr-ashwini-mr-homeopathy-cosmetic-doctor-valasaravakkam-chennai",
          },
          {
            name: "Dr. YUGANTHI DURAI",
            specialty: "Aesthetic Specialist | Dental Specialist",
            image: yuganthi,
            expertise: ["BDS, FFA, PGDMC | Exp. 2+ years"],
            experience: "2+ years",
            patients: "1900+",
            link: "/doctors/dr-yuganthi-durai-dentist-aesthetic-skin-hair-chennai",
          },
          {
            name: "Dr. DHARSHAN",
            specialty: "Homeopathy Specialist",
            image: DHARSHANDR,
            expertise: ["BHMS 1+ years"],
            experience: "1+ years",
            patients: "1900+",
            link: "/doctors/dr-s-dharshan-homeopathy-chennai",
          },
          {
            name: "Dr. NELOFAR",
            specialty: "Aesthetic Specialist | Homeopathy Specialist",
            image: NELOFARDOC,
            expertise: ["BHMS ,CGO ,CCH ,FFAC ,ADCT | Exp. 6+ years"],
            experience: "6+ years",
            patients: "1900+",
            link: "/dr-syed-nelofar-aesthetic-homoeopathy-bangalore",
          },

          {
            name: "Dr. UMA BARATHI",
            specialty: "Aesthetic Specialist | Homeopathy Specialist",
            image: UMABARATHIDR,
            expertise: ["BHMS ,PGDCC | Exp. 2+ years"],
            experience: "2+ years",
            patients: "1900+",
            link: "/doctors/dr-uma-barathi-homeopathy-aesthetic-chennai",
          },
           {
            name: "Dr. sarbarmathy",
            specialty: "Aesthetic Specialist | Dental Specialist",
            image: sarbarmathydr,
            expertise: ["BDS, | Exp. 6+ years"],
            experience: "6+ years",
            patients: "1900+",
            link: "/doctors/dr-sabarmathy-dentist-aesthetic-pondicherry",
          },
        ].map((doctor, index) => (
          <div key={index} className="doctor-card-desktop-optimized">
            <div className="doctor-image-wrapper-desktop-optimized">
              <img
                src={doctor.image}
                alt={doctor.name}
                className="doctor-image-desktop-optimized"
              />
              <div className="doctor-badge-desktop-optimized">
              </div>
              <div className="doctor-overlay-desktop-optimized">
                <div className="overlay-content-desktop-optimized">
                  <h3 className="doctor-name-desktop-optimized">
                    {doctor.name}
                  </h3>
                  <p className="doctor-specialty-desktop-optimized">
                    {doctor.specialty}
                  </p>
                  <p className="doctor-experience-desktop-optimized">
                    {doctor.experience} Experience
                  </p>

                  <div className="expertise-tags-desktop-optimized">
                    {doctor.expertise.slice(0, 3).map((skill, idx) => (
                      <span
                        key={idx}
                        className="expertise-tag-desktop-optimized"
                      >
                        {skill}
                      </span>
                    ))}
                  </div>

                  <Link
                    to={doctor.link}
                    className="read-more-btn-desktop-optimized"
                  >
                    <ChevronRight />
                    Read More
                  </Link>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>

      {/* Desktop Navigation Buttons */}
      <button
        className="scroll-btn-desktop-optimized scroll-left-desktop-optimized"
        onClick={() => {
          const container = document.querySelector(
            ".doctors-container-desktop-optimized"
          );
          container.scrollBy({ left: -350, behavior: "smooth" });
        }}
      >
        <ChevronLeft />
      </button>
      <button
        className="scroll-btn-desktop-optimized scroll-right-desktop-optimized"
        onClick={() => {
          const container = document.querySelector(
            ".doctors-container-desktop-optimized"
          );
          container.scrollBy({ left: 350, behavior: "smooth" });
        }}
      >
        <ChevronRight />
      </button>
    </div>

    {/* Mobile Clean Design - Same Image Sizes */}
    <div className="doctors-mobile-optimized">
      <div className="doctors-container-mobile-optimized">
        {[
          {
            name: "Dr.Veena M",
            specialty: "Hair & Skin Specialist",
            image: veenadoc,
            expertise: ["BHMS,FMC | Exp. 4+ years"],
            experience: "15+ years",
            patients: "2500+",
            link: "/doctors/dr-veena-m-homeopathy-aesthetics-bangalore",
          },
          {
            name: "Dr.Chayanika ",
            specialty: "Dental Specialist",
            image: Chayanika,
            expertise: ["BDS | Exp. 4+ years"],
            experience: "12+ years",
            patients: "1800+",
            link: "/doctors/dr-chayanika-ghosh-dentist-jayanagar-bangalore",
          },
          {
            name: "Dr. Spoorthi Prasad",
            specialty: "Homeopathy Specialist",
            image: spoorthi,
            expertise: ["BHMS | Exp. 8+ years"],
            experience: "18+ years",
            patients: "3200+",
            link: "/doctors/dr-spoorthi-prasad-senior-homeopathy-doctor-jayanagar-bangalore",
          },
          {
            name: "Dr. Yuvapriya",
            specialty: "Aesthetic Specialist | Dental Specialist",
            image: yuvapriya,
            expertise: ["BDS,FMC | Exp. 2+ years"],
            experience: "16+ years",
            patients: "1900+",
            link: "/doctors/dr-yuvapriya-p-dentist-aesthetic-jayanagar-bangalore",
          },
          {
            name: "Dr. Pargavi J",
            specialty: "Aesthetic Specialist | Homeopathy Specialist",
            image: pargavi,
            expertise: ["BHMS, FFAC | Exp. 2+ years"],
            experience: "16+ years",
            patients: "1900+",
            link: "/doctors/dr-j-pargavi-homeopathy-aesthetic-doctor-jayanagar-bangalore",
          },
          {
            name: "Dr. Pavithrakamatchi ",
            specialty: "Homeopathy Specialist",
            image: pavithra,
            expertise: ["BHMS | Exp. 1+ years"],
            experience: "14+ years",
            patients: "2100+",
            link: "/doctors/dr-pavithrakamatchi-jayanagar-bangalore",
          },
          {
            name: "Dr. Muthumari",
            specialty: "Aesthetic Specialist | Homeopathy Specialist",
            image: muthumari,
            expertise: ["BHMS , FFACC | Exp. 1+ years"],
            experience: "16+ years",
            patients: "1900+",
            link: "/doctors/dr-muthumari-homeopathy-facial-aesthetics-valasaravakkam-chennai",
          },
          {
            name: "Dr. Ahilan Murugadas",
            specialty: "Aesthetic Specialist | Homeopathy Specialist",
            image: ahilan,
            expertise: ["BHMS , FMC , PGDDN | Exp. 4+ years"],
            experience: "16+ years",
            patients: "1900+",
            link: "/doctors/dr-ahilan-murugadas-homeopathy-cosmetic-nutrition-gerugambakkam-chennai",
          },
          {
            name: "Dr. ASHWINI",
            specialty: "Aesthetic Specialist | Homeopathy Specialist",
            image: aswini,
            expertise: ["BHMS | Exp. 4+ years"],
            experience: "16+ years",
            patients: "1900+",
            link: "/doctors/dr-ashwini-mr-homeopathy-cosmetic-doctor-valasaravakkam-chennai",
          },
          {
            name: "Dr. Yuganthi Durai",
            specialty: "Aesthetic Specialist | Dental Specialist",
            image: yuganthi,
            expertise: ["BDS, FFA, PGDMC | Exp. 2+ years"],
            experience: "16+ years",
            patients: "1900+",
            link: "/doctors/dr-yuganthi-durai-dentist-aesthetic-skin-hair-chennai",
          },
        ].map((doctor, index) => (
          <div key={index} className="doctor-card-mobile-optimized">
            <div className="doctor-image-container-mobile-optimized">
              <img
                src={doctor.image}
                alt={doctor.name}
                className="doctor-image-mobile-optimized"
              />
              <div className="rating-overlay-mobile">
              </div>
            </div>

            <div className="doctor-info-mobile-optimized">
              <h3 className="doctor-name-mobile-optimized">
                {doctor.name}
              </h3>
              <p className="doctor-specialty-mobile-optimized">
                {doctor.specialty}
              </p>
              <p className="doctor-experience-mobile-optimized">
                {doctor.experience} Experience
              </p>

              <Link
                to={doctor.link}
                className="read-more-btn-mobile-optimized"
              >
                <ChevronRight />
                Read More
              </Link>
            </div>
          </div>
        ))}
      </div>

      {/* Mobile Navigation Buttons */}
      <button
        className="scroll-btn-mobile-optimized scroll-left-mobile-optimized"
        onClick={() => {
          const container = document.querySelector(
            ".doctors-container-mobile-optimized"
          );
          container.scrollBy({ left: -280, behavior: "smooth" });
        }}
      >
        <ChevronLeft />
      </button>
      <button
        className="scroll-btn-mobile-optimized scroll-right-mobile-optimized"
        onClick={() => {
          const container = document.querySelector(
            ".doctors-container-mobile-optimized"
          );
          container.scrollBy({ left: 280, behavior: "smooth" });
        }}
      >
        <ChevronRight />
      </button>
    </div>

    <div className="section-footer-optimized">
    </div>
  </div>
</section>

      {/* Process Timeline */}
      <section className="girukambakamchennai-process">
  <div className="girukambakamchennai-container">
    <div className="girukambakamchennai-section-header">
      <span className="header-tag-optimized">How We Help You</span>
      <h2 className="girukambakamchennai-section-title">
        Get Better in{" "}
        <span className="girukambakamchennai-gradient-text">
          3 Easy Steps
        </span>
      </h2>
      <p className="girukambakamchennai-section-description">
        Improving your health is simple—visit H-Cura Choose an in-clinic visit or speak to our doctors online—whatever is convenient for you.
      </p>
    </div>

    <div className="girukambakamchennai-timeline">
      <div className="girukambakamchennai-timeline-item">
        <div className="girukambakamchennai-timeline-marker">
          <span>01</span>
        </div>
        <div className="girukambakamchennai-timeline-content">
          <div className="girukambakamchennai-timeline-icon">
            <Calendar />
          </div>
          <h3>Book Consultation</h3>
          <p>
            Visit our clinic or consult our doctors online choose the care approach that fits your comfort.
          </p>
          <Link
            to="/bookconsultation"
            className="girukambakamchennai-timeline-btn"
          >
            Book Now
          </Link>
        </div>
      </div>

      <div className="girukambakamchennai-timeline-item">
        <div className="girukambakamchennai-timeline-marker">
          <span>02</span>
        </div>
        <div className="girukambakamchennai-timeline-content">
          <div className="girukambakamchennai-timeline-icon">
            <Video />
          </div>
          <h3>Meet Your Doctor</h3>
          <p>
            Connect with our specialist doctors through a clinic visit or video call, and receive care that truly understands your needs.
          </p>
          <Link
            to="/bookconsultation"
            className="girukambakamchennai-timeline-btn"
          >
            Learn More
          </Link>
        </div>
      </div>

      <div className="girukambakamchennai-timeline-item">
        <div className="girukambakamchennai-timeline-marker">
          <span>03</span>
        </div>
        <div className="girukambakamchennai-timeline-content">
          <div className="girukambakamchennai-timeline-icon">
            <Heart />
          </div>
          <h3>Feel Health in Every Step</h3>
          <p>
            Access high-quality care at a cost you can afford, with medicines available for pickup or convenient home delivery.
          </p>
          <Link
            to="/bookconsultation"
            className="girukambakamchennai-timeline-btn"
          >
            See Options
          </Link>
        </div>
      </div>
    </div>
  </div>
</section>

{/* Contact Section */}
      <section className="girukambakamchennai-contact">
        <div className="girukambakamchennai-container">
          <div className="girukambakamchennai-section-header">
            <span className="hcura-subtitle">Get In Touch</span>
            <h2 className="girukambakamchennai-section-title">
              Contact{" "}
              <span className="girukambakamchennai-gradient-text">
                Our Team
              </span>
            </h2>
            <p className="girukambakamchennai-section-description">
              Need assistance? We’re here to help you begin your health journey with expert care in every specialties.
            </p>
          </div>

          <div className="girukambakamchennai-contact-grid">
            <div className="girukambakamchennai-contact-info">
              <div className="girukambakamchennai-contact-item">
                <Phone />
                <div>
                  <h3>Call Us</h3>
                  <p>+91-99646 88333</p>
                </div>
              </div>

              <div className="girukambakamchennai-contact-item">
                <Mail />
                <div>
                  <h3>Email Us</h3>
                  <p>support@h-cura.com</p>
                </div>
              </div>

              <div className="girukambakamchennai-contact-item">
                <MapPin />
                <div>
                  <h3>Visit Us</h3>
                  <p>Jayanagar, Bengaluru, Karnataka 560069</p>
                  <p>10 AM to 8 PM, Monday to Sunday</p>
                </div>
              </div>
            </div>

            {/* Consultation Form with Success Message Integration */}
            <div className="girukambakamchennai-contact-form">
              {loading && <LoadingBar />}

              {showSuccessMessage ? (
                <div className="girukambakamchennai-success-overlay">
                  <div className="girukambakamchennai-success-icon">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 24 24"
                      fill="currentColor"
                      className="w-12 h-12"
                    >
                      <path
                        fillRule="evenodd"
                        d="M2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12Zm13.36-1.814a.75.75 0 1 0-1.22-.872l-3.236 4.53L9.53 12.22a.75.75 0 0 0-1.06 1.06l2.25 2.25a.75.75 0 0 0 1.14-.094l3.75-5.25Z"
                        clipRule="evenodd"
                      />
                    </svg>
                  </div>
                  <h2 className="girukambakamchennai-success-heading">
                    Successfully Submitted!
                  </h2>
                  <p className="girukambakamchennai-success-message-text">
                    Thank you for your consultation request. Our team will get
                    back to you shortly.
                  </p>
                  <button
                    onClick={() => setShowSuccessMessage(false)}
                    className="girukambakamchennai-success-btn"
                  >
                    Close
                  </button>
                </div>
              ) : (
                <>
                  <h2 className="girukambakamchennai-form-heading">
                    Consultation Form
                  </h2>
                  <form onSubmit={handleSubmit}>
                    {/* Name and Age */}
                    <div className="girukambakamchennai-form-row">
                      <div className="girukambakamchennai-form-group">
                        <label>
                          Name:<span>*</span>
                        </label>
                        <input
                          type="text"
                          name="name"
                          placeholder="Full Name"
                          value={formData.name}
                          onChange={handleChange}
                          required
                        />
                        {errors.name && (
                          <span className="girukambakamchennai-error">
                            {errors.name}
                          </span>
                        )}
                      </div>
                      <div className="girukambakamchennai-form-group">
                        <label>Age:</label>
                        <input
                          type="number"
                          name="age"
                          placeholder="Your Age"
                          value={formData.age}
                          onChange={handleChange}
                        />
                        {errors.age && (
                          <span className="girukambakamchennai-error">
                            {errors.age}
                          </span>
                        )}
                      </div>
                    </div>

                    {/* Phone Number and State */}
                    <div className="girukambakamchennai-form-row">
                      <div className="girukambakamchennai-form-group">
                        <label>
                          Phone Number:<span>*</span>
                        </label>
                        <input
                          type="text"
                          name="phoneNo"
                          placeholder="Phone Number"
                          value={formData.phoneNo}
                          onChange={handleChange}
                          required
                        />
                        {errors.phoneNo && (
                          <span className="girukambakamchennai-error">
                            {errors.phoneNo}
                          </span>
                        )}
                      </div>
                      <div className="girukambakamchennai-form-group">
                        <label>State:</label>
                        <input
                          type="text"
                          name="state"
                          placeholder="Your State"
                          value={formData.state}
                          onChange={handleChange}
                        />
                        {errors.state && (
                          <span className="girukambakamchennai-error">
                            {errors.state}
                          </span>
                        )}
                      </div>
                    </div>

                    {/* Dropdown for Selecting Concern */}
                    <div className="girukambakamchennai-form-group">
                      <label>
                        Select Your Concern:<span>*</span>
                      </label>
                      <select
                        name="concern"
                        value={formData.concern}
                        onChange={handleChange}
                        required
                      >
                        <option value="">Select a concern</option>
                        <option value="homeopathy">Homeopathy</option>
                        <option value="advanced_skin">Aesthetic hair</option>
                        <option value="advanced_hair">Aesthetic skin</option>
                        <option value="dental">Dental</option>
                      </select>
                      {errors.concern && (
                        <span className="girukambakamchennai-error">
                          {errors.concern}
                        </span>
                      )}
                    </div>

                    {/* Consultation Type */}
                    <div className="girukambakamchennai-form-group">
                      <label>
                        Consultation Type:<span>*</span>
                      </label>
                      <div className="girukambakamchennai-radio-group">
                        <label>
                          <input
                            type="radio"
                            name="consultationType"
                            value="online"
                            checked={formData.consultationType === "online"}
                            onChange={handleConsultationTypeChange}
                          />
                          Online
                        </label>
                        <label>
                          <input
                            type="radio"
                            name="consultationType"
                            value="offline"
                            checked={formData.consultationType === "offline"}
                            onChange={handleConsultationTypeChange}
                          />
                          Offline
                        </label>
                      </div>
                      {errors.consultationType && (
                        <span className="girukambakamchennai-error">
                          {errors.consultationType}
                        </span>
                      )}
                    </div>

                    {/* Branch Dropdown */}
                    {showBranches && (
                      <div className="girukambakamchennai-form-group">
                        <label>
                          Select Branch:<span>*</span>
                        </label>
                        <select
                          name="branch"
                          value={formData.branch}
                          onChange={handleChange}
                          required
                        >
                          <option value="">Select a branch</option>
                          {BRANCH_OPTIONS.map((branch) => (
                            <option key={branch.value} value={branch.value}>
                              {branch.label}
                            </option>
                          ))}
                        </select>
                        {errors.branch && (
                          <span className="girukambakamchennai-error">
                            {errors.branch}
                          </span>
                        )}
                      </div>
                    )}

                    {/* Problem Description */}
                    <div className="girukambakamchennai-form-group">
                      <label>Description:</label>
                      <textarea
                        name="message"
                        placeholder="Describe your health issue"
                        value={formData.message}
                        onChange={handleChange}
                        rows="4"
                      />
                      {errors.message && (
                        <span className="girukambakamchennai-error">
                          {errors.message}
                        </span>
                      )}
                    </div>

                    <button
                      type="submit"
                      className="girukambakamchennai-submit-btn"
                      disabled={loading}
                    >
                      {loading ? "Submitting..." : "Submit"}
                    </button>
                  </form>
                </>
              )}
              <ToastContainer />
            </div>
          </div>
        </div>
      </section>

      {/* Before & After Section */}
      <section className="girukambakamchennai-before-after">
        <div className="girukambakamchennai-container">
          <div className="girukambakamchennai-section-header">
            <span className="hcura-subtitle">Real Results</span>
            <h2 className="girukambakamchennai-section-title">
              Transformations That Speak {" "}
              <span className="girukambakamchennai-gradient-text">
                 for Our Performance and Professionalism
              </span>
            </h2>
            <p className="girukambakamchennai-section-description">
              See the incredible results our patients have achieved with
              personalized treatments across all specialties.
            </p>
          </div>

          <div className="girukambakamchennai-before-tabs">
            <button
              className={`girukambakamchennai-ba-tab \${
                activeTab === "hair" ? "active" : ""
              }`}
              onClick={() => setActiveTab("hair")}
            >
              Hair Treatment
              <div className="girukambakamchennai-tab-indicator"></div>
            </button>
            <button
              className={`girukambakamchennai-ba-tab \${
                activeTab === "skin" ? "active" : ""
              }`}
              onClick={() => setActiveTab("skin")}
            >
              Skin Treatment
              <div className="girukambakamchennai-tab-indicator"></div>
            </button>
          </div>

          <div className="girukambakamchennai-before-carousel-wrapper">
            <div className="girukambakamchennai-before-carousel">
              {beforeAfterData[activeTab]?.map((item, index) => (
                <div
                  key={item.id}
                  className="girukambakamchennai-ba-clean-card"
                >
                  <div className="girukambakamchennai-ba-clean-container">
                    <div className="girukambakamchennai-ba-clean-image-wrapper">
                      <img
                        src={item.combined}
                        alt={item.title}
                        className="girukambakamchennai-ba-clean-image"
                      />
                      <div className="girukambakamchennai-ba-clean-title">
                        <h4>{item.title}</h4>
                      </div>
                    </div>
                    <div className="girukambakamchennai-ba-clean-actions">
                      <button
                        className="girukambakamchennai-ba-clean-view-btn"
                        onClick={() => openModal(activeTab)}
                      >
                        View Results
                      </button>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* Modal */}
        {selectedModal && (
          <div className="girukambakamchennai-ba-modal">
            <div
              className="girukambakamchennai-ba-modal-backdrop"
              onClick={closeModal}
            ></div>
            <div className="girukambakamchennai-ba-modal-panel">
              <div className="girukambakamchennai-ba-modal-header">
                <h3>
                  {selectedModal === "hair"
                    ? "Hair Treatment Results"
                    : "Skin Treatment Results"}
                </h3>
                <button
                  className="girukambakamchennai-ba-modal-close"
                  onClick={closeModal}
                >
                  ×
                </button>
              </div>

              <div className="girukambakamchennai-ba-modal-body">
                <div className="girukambakamchennai-ba-scrollable-container">
                  <div className="girukambakamchennai-ba-scroll-track">
                    <div className="girukambakamchennai-ba-scrollable-grid">
                      {beforeAfterData[selectedModal]?.map((item, index) => (
                        <div
                          key={item.id}
                          className="girukambakamchennai-ba-scrollable-card"
                        >
                          <div className="girukambakamchennai-ba-scrollable-image-container">
                            <img
                              src={item.combined}
                              alt={item.title}
                              className="girukambakamchennai-ba-scrollable-image"
                            />
                          </div>
                          <div className="girukambakamchennai-ba-scrollable-content">
                            <h4>{item.title}</h4>
                            <p className="girukambakamchennai-ba-scrollable-testimonial">
                              "{item.testimonial.quote}"
                            </p>
                            <p className="girukambakamchennai-ba-scrollable-author">
                              - {item.testimonial.author}
                            </p>
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>

                <div className="girukambakamchennai-ba-enhanced-controls">
                  <div className="girukambakamchennai-ba-nav-buttons">
                    <button
                      className="girukambakamchennai-ba-nav-btn"
                      onClick={prevSlide}
                    >
                      ← Previous
                    </button>
                    <button
                      className="girukambakamchennai-ba-nav-btn"
                      onClick={nextSlide}
                    >
                      Next →
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      </section>

      {/* Testimonials Section */}
      <Testimonials />

      <section className="hcura-interactive-locations">
        <div className="hcura-interactive-container">
          {/* Header */}
          <div className="hcura-interactive-header">
            <div className="hcura-interactive-subtitle">Our Network</div>
            <h2 className="hcura-interactive-title">
              Choose Your{" "}
              <span className="hcura-interactive-gradient-text">Location</span>
            </h2>
            <p className="hcura-interactive-description">
              Select a city to explore our branches and services in that area
            </p>
          </div>

          {(!showLocationDetails || window.innerWidth > 768) && (
            <div className="hcura-location-tabs">
              <button
                className={`hcura-location-tab \${
                  selectedLocation === "chennai" ? "active" : ""
                }`}
                onClick={() => handleLocationClick("chennai")}
              >
                <div className="hcura-tab-icon">
                  <svg viewBox="0 0 24 24" fill="currentColor">
                    <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z" />
                  </svg>
                </div>
                <div className="hcura-tab-content">
                  <h3>Chennai</h3>
                  <span>5 Branches</span>
                </div>
                <div className="hcura-tab-badge">Headquarters</div>
              </button>

              <button
                className={`hcura-location-tab \${
                  selectedLocation === "bangalore" ? "active" : ""
                }`}
                onClick={() => handleLocationClick("bangalore")}
              >
                <div className="hcura-tab-icon">
                  <svg viewBox="0 0 24 24" fill="currentColor">
                    <path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z" />
                  </svg>
                </div>
                <div className="hcura-tab-content">
                  <h3>Bangalore</h3>
                  <span>1 Branch</span>
                </div>
                <div className="hcura-tab-badge">Tech Hub</div>
              </button>

              <button
                className={`hcura-location-tab \${
                  selectedLocation === "pondicherry" ? "active" : ""
                }`}
                onClick={() => handleLocationClick("pondicherry")}
              >
                <div className="hcura-tab-icon">
                  <svg viewBox="0 0 24 24" fill="currentColor">
                    <path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z" />
                  </svg>
                </div>
                <div className="hcura-tab-content">
                  <h3>Pondicherry</h3>
                  <span>1 Branch</span>
                </div>
                <div className="hcura-tab-badge">Coastal</div>
              </button>
            </div>
          )}

          {/* Dynamic Content Area - Show when showLocationDetails is true */}
          {showLocationDetails && (
            <div className="hcura-location-content">
              {/* Chennai Content */}
              {selectedLocation === "chennai" && (
                <div className="hcura-content-panel hcura-chennai-panel">
                  <div className="hcura-branches-grid">
                    {[
                      {
                        name: "Valasaravakkam",
                        area: "West Chennai",
                        status: clinicStatus,
                        address:
                          "48, 1st Main Rd, Krishnamachari Nagar, Valasaravakkam, Chennai, Tamil Nadu 600116",
                        mapUrl:
                          "https://www.google.com/maps/place/H-Cura+Multispeciality+Clinic,+Valasaravakkam+-+Chennai+%7C+Advanced+Hair,+Skin,+Homeopathy+%26+Dental+Treatments/@13.0418594,80.1671557,17z/data=!3m1!4b1!4m6!3m5!1s0x3a52615c36adbb19:0x472a744277cc9342!8m2!3d13.0418542!4d80.1697306!16s%2Fg%2F11y6b43g0z?entry=ttu&g_ep=EgoyMDI1MTAwOC4wIKXMDSoASAFQAw%3D%3D",
                      },
                      {
                        name: "Gerugambakkam",
                        area: "West Chennai",
                        status: clinicStatus,
                        address:
                          "1668, Ground floor, Sathyavanimuthu Street, Ramachandra Nagar, Keezh Colony, Gerugambakkam, Chennai, Tamil Nadu 600128",
                        mapUrl:
                          "https://www.google.com/maps/place/H-Cura+Multispeciality+Clinic+%E2%80%93+Gerugambakkam,+Chennai+%7C+Advanced+Skin,+Hair,+Dental+%26+Homeopathy+Treatments/@12.9974076,80.1453354,14.29z/data=!4m6!3m5!1s0x3a5261abfaf0057d:0x475d5e19a5f38e89!8m2!3d13.0108873!4d80.1444788!16s%2Fg%2F11x7y0rdvw?entry=ttu&g_ep=EgoyMDI1MTAwOC4wIKXMDSoASAFQAw%3D%3D",
                      },
                      {
                        name: "Tambaram",
                        area: "South Chennai",
                        status: clinicStatus,
                        address:
                          "No 05, Ground Floor, Gandhi Rd, Next to ST Courier, Opposite Valluvar Gurukulam, West Tambaram, Chennai, Tamil Nadu 600045",
                        mapUrl:
                          "https://www.google.com/maps/place/H-Cura+Multispeciality+Clinic+%E2%80%93Tambaram,+Chennai+%7C+Advanced+Hair,+Skin,+Homeopathy+%26+Dental+Treatments/@13.0011695,80.1059933,12.13z/data=!4m14!1m7!3m6!1s0x3a5261abfaf0057d:0x475d5e19a5f38e89!2sH-Cura+Multispeciality+Clinic+%E2%80%93+Gerugambakkam,+Chennai+%7C+Advanced+Skin,+Hair,+Dental+%26+Homeopathy+Treatments!8m2!3d13.0108873!4d80.1444788!16s%2Fg%2F11x7y0rdvw!3m5!1s0x3a525f992abea45f:0x27ba36bdb03c2689!8m2!3d12.9300426!4d80.1202723!16s%2Fg%2F11ykkrgnvn?entry=ttu&g_ep=EgoyMDI1MTAwOC4wIKXMDSoASAFQAw%3D%3D",
                      },
                      
                      
                      {
                        name: "Navalur",
                        area: "North Chennai",
                        status: clinicStatus,
                        address:
                          "DRA CENTRALIA NAVALUR ,THALAMBUR  ROAD, NAVALUR  , Chennai - 600130",
                      },
                      {
                        name: "Vadapalani",
                        area: "South Chennai",
                        status: clinicStatus,
                        address: "No: 193 (301), NSK Salai , Kodambakkam N 132, Metro Pillar no : 4 Opposite, Kodambakkam, Chennai - 600024.",
                      },
                    ].map((branch, index) => (
                      <div key={index} className="hcura-branch-detail-card">
                        <div className="hcura-branch-header">
                          <div className="hcura-branch-main">
                            <h4>{branch.name}</h4>
                            <span className="hcura-branch-area">
                              {branch.area}
                            </span>
                          </div>
                          <div
                            className={`hcura-status-badge ${branch.status.toLowerCase()}`}
                          >
                            <div className="hcura-status-dot"></div>
                            {branch.status}
                          </div>
                        </div>

                        <div className="hcura-branch-address">
                          <span className="hcura-address-label">Address:</span>
                          <div className="hcura-address-text">
                            {branch.address}
                          </div>
                        </div>

                        <div className="hcura-branch-actions">
                          <button
                            className="hcura-action-btn hcura-directions-btn"
                            onClick={() =>
                              branch.mapUrl &&
                              window.open(branch.mapUrl, "_blank")
                            }
                          >
                            <svg viewBox="0 0 24 24" fill="currentColor">
                              <path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z" />
                            </svg>
                            Directions
                          </button>
                          <button className="hcura-action-btn hcura-book-btn">
                            <svg viewBox="0 0 24 24" fill="currentColor">
                              <path d="M19 3h-1V1h-2v2H8V1H6v2H5A2,2 0 0,0 3,5V19A2,2 0 0,0 5,21H19A2,2 0 0,0 21,19V5A2,2 0 0,0 19,3M19,19H5V8H19V19Z" />
                            </svg>
                            Book Now
                          </button>
                        </div>
                      </div>
                    ))}

                  </div>

                  <div className="hcura-panel-footer">
                    <div className="hcura-contact-info">
                      <div className="hcura-timing">
                        <svg viewBox="0 0 24 24" fill="currentColor">
                          <path d="M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2M16.2,16.2L11,13V7H12.5V12.2L17,14.7L16.2,16.2Z" />
                        </svg>
                        <span>All branches open daily: 10 AM - 8 PM</span>
                      </div>
                      <button
                        className="hcura-contact-chennai"
                        onClick={() =>
                          window.open("https://wa.me/917411845662", "_blank")
                        }
                      >
                        <svg viewBox="0 0 24 24" fill="currentColor">
                          <path d="M6.62 10.79c1.44 2.83 3.76 5.14 6.59 6.59l2.2-2.2c.27-.27.67-.36 1.02-.24 1.12.37 2.33.57 3.57.57.55 0 1 .45 1 1V20c0 .55-.45 1-1 1-9.39 0-17-7.61-17-17 0-.55.45-1 1-1h3.5c.55 0 1 .45 1 1 0 1.25.2 2.45.57 3.57.11.35.03.74-.25 1.02l-2.2 2.2z" />
                        </svg>
                        Contact Chennai Support
                      </button>
                    </div>
                  </div>
                </div>
              )}

              {/* Bangalore Content */}
              {selectedLocation === "bangalore" && (
                <div className="hcura-content-panel hcura-bangalore-panel">
                  <div className="hcura-single-branch-showcase">
                    <div className="hcura-branch-hero">
                      <div className="hcura-branch-image">
                        <div className="hcura-image-placeholder">
                          <svg viewBox="0 0 24 24" fill="currentColor">
                            <path d="M19 7h-3V6a4 4 0 0 0-8 0v1H5a1 1 0 0 0-1 1v11a3 3 0 0 0 3 3h10a3 3 0 0 0 3-3V8a1 1 0 0 0-1-1zM10 6a2 2 0 0 1 4 0v1h-4V6zm8 13a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1V9h2v1a1 1 0 0 0 2 0V9h4v1a1 1 0 0 0 2 0V9h2v10z" />
                          </svg>
                        </div>
                      </div>
                      <div className="hcura-branch-details">
                        <h4>H-Cura Jayanagar</h4>
                        <div className="hcura-address">
                          <svg viewBox="0 0 24 24" fill="currentColor">
                            <path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z" />
                          </svg>
                          <span>
                            No:779&780 2rd Floor, Sai Towers Building, South, E
                            End Main Rd, opposite to Metro Pillar No 92,
                            Corporation Colony, Jayanagara 9th Block, Jayanagar,
                            Bengaluru, Karnataka 560041
                          </span>
                        </div>
                        <div className="hcura-phone">
                          <svg viewBox="0 0 24 24" fill="currentColor">
                            <path d="M6.62 10.79c1.44 2.83 3.76 5.14 6.59 6.59l2.2-2.2c.27-.27.67-.36 1.02-.24 1.12.37 2.33.57 3.57.57.55 0 1 .45 1 1V20c0 .55-.45 1-1 1-9.39 0-17-7.61-17-17 0-.55.45-1 1-1h3.5c.55 0 1 .45 1 1 0 1.25.2 2.45.57 3.57.11.35.03.74-.25 1.02l-2.2 2.2z" />
                          </svg>
                          <span>+91-99646 88333</span>
                        </div>
                        <div className={`hcura-status-badge ${clinicStatus.toLowerCase()}`}>
                          <div className="hcura-status-dot"></div>
                          {clinicStatus}
                        </div>
                      </div>
                    </div>

                    <div className="hcura-services-grid">
                      <div className="hcura-service-category">
                        <h5>Hair Treatment</h5>
                        <ul>
                          <li>PRP Therapy</li>
                          <li>GFC Therapy</li>
                          <li>Stem Cell Hair Therapy</li>
                          <li>Exosome Hair Therapy</li>
                        </ul>
                      </div>
                      <div className="hcura-service-category">
                        <h5>Skin Treatment</h5>
                        <ul>
                          <li>Acne Treatment</li>
                          <li>Anti-Aging Solutions</li>
                          <li>Skin Rejuvenation</li>
                        </ul>
                      </div>
                      <div className="hcura-service-category">
                        <h5>Homeopathy</h5>
                        <ul>
                          <li>Alopecia Areata</li>
                          <li>Migraine & Chronic Headache Relief</li>
                          <li>Anxiety & Depression</li>
                        </ul>
                      </div>
                      <div className="hcura-service-category">
                        <h5>dental Care</h5>
                        <ul>
                          <li>Scaling & Polishing</li>
                          <li>Endodontics</li>
                          <li>Prosthodontics</li>
                           <li>Periodontics</li>

                        </ul>
                      </div>
                    </div>

                    <div className="hcura-branch-features">
                      <div className="hcura-feature">
                        <div className="hcura-feature-icon">
                          <svg viewBox="0 0 24 24" fill="currentColor">
                            <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z" />
                          </svg>
                        </div>
                        <span>Premium Facility</span>
                      </div>
                      <div className="hcura-feature">
                        <div className="hcura-feature-icon">
                          <svg viewBox="0 0 24 24" fill="currentColor">
                            <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z" />
                          </svg>
                        </div>
                        <span>Latest Equipment</span>
                      </div>
                      <div className="hcura-feature">
                        <div className="hcura-feature-icon">
                          <svg viewBox="0 0 24 24" fill="currentColor">
                            <path d="M17 12h-5v5h5v-5zM16 1v2H8V1H6v2H5c-1.1 0-1.99.9-1.99 2L3 19c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2h-1V1h-2zm3 18H5V8h14v11z" />
                          </svg>
                        </div>
                        <span>Easy Parking</span>
                      </div>
                    </div>
                  </div>

                  <div className="hcura-panel-footer">
                    <div className="hcura-contact-info">
                      <div className="hcura-timing">
                        <svg viewBox="0 0 24 24" fill="currentColor">
                          <path d="M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2M16.2,16.2L11,13V7H12.5V12.2L17,14.7L16.2,16.2Z" />
                        </svg>
                        <span>Open daily: 10 AM - 8 PM</span>
                      </div>
                      <div className="hcura-action-buttons">
                        <button
                          className="hcura-directions-btn"
                          onClick={() =>
                            window.open(
                              "https://www.google.com/maps/place/H-Cura+Multispeciality+Clinic,+Jayanagar-+Bangalore+%7C+Best+in+Homeopathy,+Skin,+Hair,+and+Dental/@12.9170114,77.5931846,17z/data=!3m1!4b1!4m6!3m5!1s0x3bae14d8dd315555:0x837b338b42d71825!8m2!3d12.9170062!4d77.5957595!16s%2Fg%2F11sh00v1sz?entry=ttu&g_ep=EgoyMDI1MTAwOC4wIKXMDSoASAFQAw%3D%3D",
                              "_blank"
                            )
                          }
                        >
                          Get Directions
                        </button>
                        <button
                          className="hcura-call-btn"
                          onClick={() =>
                            window.open("https://wa.me/919964688333", "_blank")
                          }
                        >
                          WhatsApp +91-99646 88333
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              )}

              {/* Pondicherry Content */}
              {selectedLocation === "pondicherry" && (
               <div className="hcura-content-panel hcura-bangalore-panel">
                  <div className="hcura-single-branch-showcase">
                    <div className="hcura-branch-hero">
                      <div className="hcura-branch-image">
                        <div className="hcura-image-placeholder">
                          <svg viewBox="0 0 24 24" fill="currentColor">
                            <path d="M19 7h-3V6a4 4 0 0 0-8 0v1H5a1 1 0 0 0-1 1v11a3 3 0 0 0 3 3h10a3 3 0 0 0 3-3V8a1 1 0 0 0-1-1zM10 6a2 2 0 0 1 4 0v1h-4V6zm8 13a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1V9h2v1a1 1 0 0 0 2 0V9h4v1a1 1 0 0 0 2 0V9h2v10z" />
                          </svg>
                        </div>
                      </div>
                      <div className="hcura-branch-details">
                        <h4>H-Cura Pondicherry</h4>
                        <div className="hcura-address">
                          <svg viewBox="0 0 24 24" fill="currentColor">
                            <path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z" />
                          </svg>
                          <span>
                            RS No 243, new no : 2, 1st floor , vallar salai road , venkata nagar , Puducherry,
PUDUCHERRY - 605011
                          </span>
                        </div>
                        <div className="hcura-phone">
                          <svg viewBox="0 0 24 24" fill="currentColor">
                            <path d="M6.62 10.79c1.44 2.83 3.76 5.14 6.59 6.59l2.2-2.2c.27-.27.67-.36 1.02-.24 1.12.37 2.33.57 3.57.57.55 0 1 .45 1 1V20c0 .55-.45 1-1 1-9.39 0-17-7.61-17-17 0-.55.45-1 1-1h3.5c.55 0 1 .45 1 1 0 1.25.2 2.45.57 3.57.11.35.03.74-.25 1.02l-2.2 2.2z" />
                          </svg>
                          <span>+91 74118 47109</span>
                        </div>
                        <div className={`hcura-status-badge \${clinicStatus.toLowerCase()}`}>
                          <div className="hcura-status-dot"></div>
                          {clinicStatus}
                        </div>
                      </div>
                    </div>

                    <div className="hcura-services-grid">
                      <div className="hcura-service-category">
                        <h5>Hair Treatment</h5>
                        <ul>
                          <li>PRP Therapy</li>
                          <li>GFC Therapy</li>
                          <li>Stem Cell Hair Therapy</li>
                          <li>Exosome Hair Therapy</li>
                        </ul>
                      </div>
                      <div className="hcura-service-category">
                        <h5>Skin Treatment</h5>
                        <ul>
                          <li>Acne Treatment</li>
                          <li>Anti-Aging Solutions</li>
                          <li>Skin Rejuvenation</li>
                        </ul>
                      </div>
                      <div className="hcura-service-category">
                        <h5>Homeopathy</h5>
                        <ul>
                          <li>Alopecia Areata</li>
                          <li>Migraine & Chronic Headache Relief</li>
                          <li>Anxiety & Depression</li>
                        </ul>
                      </div>
                      <div className="hcura-service-category">
                        <h5>dental Care</h5>
                        <ul>
                          <li>Scaling & Polishing</li>
                          <li>Endodontics</li>
                          <li>Prosthodontics</li>
                           <li>Periodontics</li>

                        </ul>
                      </div>
                    </div>

                    <div className="hcura-branch-features">
                      <div className="hcura-feature">
                        <div className="hcura-feature-icon">
                          <svg viewBox="0 0 24 24" fill="currentColor">
                            <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z" />
                          </svg>
                        </div>
                        <span>Premium Facility</span>
                      </div>
                      <div className="hcura-feature">
                        <div className="hcura-feature-icon">
                          <svg viewBox="0 0 24 24" fill="currentColor">
                            <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z" />
                          </svg>
                        </div>
                        <span>Latest Equipment</span>
                      </div>
                      <div className="hcura-feature">
                        <div className="hcura-feature-icon">
                          <svg viewBox="0 0 24 24" fill="currentColor">
                            <path d="M17 12h-5v5h5v-5zM16 1v2H8V1H6v2H5c-1.1 0-1.99.9-1.99 2L3 19c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2h-1V1h-2zm3 18H5V8h14v11z" />
                          </svg>
                        </div>
                        <span>Easy Parking</span>
                      </div>
                    </div>
                  </div>

                  <div className="hcura-panel-footer">
                    <div className="hcura-contact-info">
                      <div className="hcura-timing">
                        <svg viewBox="0 0 24 24" fill="currentColor">
                          <path d="M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2M16.2,16.2L11,13V7H12.5V12.2L17,14.7L16.2,16.2Z" />
                        </svg>
                        <span>Open daily: 10 AM - 8 PM</span>
                      </div>
                      <div className="hcura-action-buttons">
                        <button
                          className="hcura-directions-btn"
                          onClick={() =>
                            window.open(
                              "https://www.google.com/maps/place/Linga/@11.9408149,79.8252644,18.59z/data=!4m6!3m5!1s0x3a53610019e5c2ab:0x225fc24db036890d!8m2!3d11.940755!4d79.8261991!16s%2Fg%2F11yds9c41l?entry=ttu&g_ep=EgoyMDI1MTExMi4wIKXMDSoASAFQAw%3D%3D",
                              "_blank"
                            )
                          }
                        >
                          Get Directions
                        </button>
                        <button
                          className="hcura-call-btn"
                          onClick={() =>
                            window.open("https://wa.me/+917411847109", "_blank")
                          }
                        >
                          WhatsApp +91 74118 47109
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>
          )}

          {/* Remaining Location Tabs - Show BELOW content on small screens when details are visible */}
          {showLocationDetails && window.innerWidth <= 768 && (
            <div className="hcura-location-tabs hcura-remaining-tabs">
              {selectedLocation !== "chennai" && (
                <button
                  className="hcura-location-tab"
                  onClick={() => handleLocationClick("chennai")}
                >
                  <div className="hcura-tab-icon">
                    <svg viewBox="0 0 24 24" fill="currentColor">
                      <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z" />
                    </svg>
                  </div>
                  <div className="hcura-tab-content">
                    <h3>Chennai</h3>
                    <span>10 Branches</span>
                  </div>
                  <div className="hcura-tab-badge">Headquarters</div>
                </button>
              )}

              {selectedLocation !== "bangalore" && (
                <button
                  className="hcura-location-tab"
                  onClick={() => handleLocationClick("bangalore")}
                >
                  <div className="hcura-tab-icon">
                    <svg viewBox="0 0 24 24" fill="currentColor">
                      <path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z" />
                    </svg>
                  </div>
                  <div className="hcura-tab-content">
                    <h3>Bangalore</h3>
                    <span>1 Branch</span>
                  </div>
                  <div className="hcura-tab-badge">Tech Hub</div>
                </button>
              )}

              {selectedLocation !== "pondicherry" && (
                <button
                  className="hcura-location-tab"
                  onClick={() => handleLocationClick("pondicherry")}
                >
                  <div className="hcura-tab-icon">
                    <svg viewBox="0 0 24 24" fill="currentColor">
                      <path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z" />
                    </svg>
                  </div>
                  <div className="hcura-tab-content">
                    <h3>Pondicherry</h3>
                    <span>1 Branch</span>
                  </div>
                  <div className="hcura-tab-badge">Coastal</div>
                </button>
              )}
            </div>
          )}
        </div>
      </section>

      {/* App Download Section */}
     <section className="girukambakamchennai-app-download">
  <div className="girukambakamchennai-container">
    <div className="girukambakamchennai-app-content">
      <div className="girukambakamchennai-app-info">
        <h2>Download the H-Cura App</h2>
        <p>
          Get instant access to expert consultations across all
          specialties, track your health progress, and manage your
          treatment plan - all in one convenient app.
        </p>

        <div className="girukambakamchennai-app-features">
          <div className="girukambakamchennai-app-feature">
            <CheckCircle />
            <span>Book consultations across all specialties</span>
          </div>
          <div className="girukambakamchennai-app-feature">
            <CheckCircle />
            <span>Track treatment progress</span>
          </div>
          <div className="girukambakamchennai-app-feature">
            <CheckCircle />
            <span>Secure health records</span>
          </div>
          <div className="girukambakamchennai-app-feature">
            <CheckCircle />
            <span>Medicine delivery tracking</span>
          </div>
        </div>

      </div>

      <div className="girukambakamchennai-app-mockup">
        <img src={homeConsultation} alt="H-Cura Mobile App" />
      </div>
    </div>
  </div>
</section>


      {/* FAQ Section */}
      <section className="girukambakamchennai-faq">
        <div className="girukambakamchennai-container">
          <div className="girukambakamchennai-section-header">
            <span className="hcura-subtitle">FAQ</span>
            <h2 className="girukambakamchennai-section-title">
              Frequently Asked{" "}
              <span className="girukambakamchennai-gradient-text">
                Questions
              </span>
            </h2>
            <p className="girukambakamchennai-section-description">
              Get answers to common questions about our multispecialty
              treatments and services.
            </p>
          </div>
          <div className="girukambakamchennai-faq-list">
            {faqData.map((faq, index) => (
              <div key={index} className="girukambakamchennai-faq-item">
                <button
                  className="girukambakamchennai-faq-question"
                  onClick={() => toggleFAQ(index)}
                >
                  <span>{faq.question}</span>
                  <ChevronDown
                    className={
                      expandedFAQ === index ? "girukambakamchennai-rotated" : ""
                    }
                  />
                </button>
                {expandedFAQ === index && (
                  <div className="girukambakamchennai-faq-answer">
                    <p>{faq.answer}</p>
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Health Tips Section */}
     <section className="girukambakamchennai-health-tips">
  <div className="girukambakamchennai-container">
    <div className="girukambakamchennai-section-header">
      <span className="hcura-subtitle">Health Tips</span>
      <h2 className="girukambakamchennai-section-title">
        Expert{" "}
        <span className="girukambakamchennai-gradient-text">
          Health Advice
        </span>
      </h2>
      <p className="girukambakamchennai-section-description">
        Stay informed with the latest health tips and advice from our
        specialist doctors.
      </p>
    </div>

    <div className="girukambakamchennai-tips-grid">
      {[
        {
          title: "10 Natural Ways to Prevent Hair Loss",
          category: "Hair Care",
          image:
            "https://images.unsplash.com/photo-1580618672591-eb180b1a973f?w=400&h=250&fit=crop",
          excerpt:
            "Discover natural methods to maintain healthy hair and prevent hair loss effectively.",
          readTime: "5 min read",
          link: "/growhair-therapy-hair-fall-treatment",
        },
        {
          title: "Daily Skincare Routine for Glowing Skin",
          category: "Skin Care",
          image:
            "https://images.unsplash.com/photo-1570172619644-dfd03ed5d881?w=400&h=250&fit=crop",
          excerpt:
            "Learn the essential steps for a daily skincare routine that promotes healthy, glowing skin.",
          readTime: "7 min read",
          link: "/glowing-skin-treatment",
        },
        {
          title: "Maintaining Oral Health: Expert Tips",
          category: "Dental Care",
          image:
            "https://images.unsplash.com/photo-1606811971618-4486d14f3f99?w=400&h=250&fit=crop",
          excerpt:
            "Essential dental care tips from our expert dentists for optimal oral health.",
          readTime: "4 min read",
          link: "/tips/oral-health",
        },
      ].map((tip, index) => (
        <div key={index} className="girukambakamchennai-tip-card">
          <div className="girukambakamchennai-tip-image">
            <img src={tip.image} alt={tip.title} />
            <span className="girukambakamchennai-tip-category">
              {tip.category}
            </span>
          </div>
          <div className="girukambakamchennai-tip-content">
            <h3>{tip.title}</h3>
            <p>{tip.excerpt}</p>
            <div className="girukambakamchennai-tip-meta">
              <span className="girukambakamchennai-read-time">
                <Clock />
                {tip.readTime}
              </span>
              <Link
                to={tip.link}
                className="girukambakamchennai-read-more"
              >
                Read More
                <ChevronRight />
              </Link>
            </div>
          </div>
        </div>
      ))}
    </div>

    <div className="girukambakamchennai-tips-cta">
      <Link
        to="/blog"
        className="girukambakamchennai-view-all-tips-btn"
      >
        View All Health Tips
        <ChevronRight />
      </Link>
    </div>
  </div>
</section>



      {/* CTA Section */}
 <section className="girukambakamchennai-cta">
  <div className="girukambakamchennai-container">
    <div className="girukambakamchennai-cta-content">
      <h2>Improve your health and boost your confidence with proven care.</h2>
      <p>
        Join 1,00,000+ happy patients who chose H-Cura for guaranteed results 
        in Hair, Skin, Dental & Homeopathy treatments.
      </p>

      <div className="girukambakamchennai-guarantee-badges">
        <div className="girukambakamchennai-guarantee-item">
          <Shield />
          <span>100% Natural</span>
        </div>
        <div className="girukambakamchennai-guarantee-item">
          <Award />
          <span>Expert Doctors</span>
        </div>
        <div className="girukambakamchennai-guarantee-item">
          <CheckCircle />
          <span>Proven Results</span>
        </div>
      </div>

      <div className="girukambakamchennai-offer-badge">
        🎯 Special Offer: Free Consultation Worth ₹500
      </div>

      <div className="girukambakamchennai-cta-buttons">
        <Link
          to="/book-consultation"
          className="girukambakamchennai-cta-primary"
        >
          <Video />
          Book Free Consultation
        </Link>
        <a
          href="tel:+91-99646 88333"
          className="girukambakamchennai-cta-secondary"
        >
          <Phone />
          Call:+91-99646 88333
        </a>
      </div>
    </div>
  </div>
</section>




    </div>
  );
};

export default HCuraHomepage;


          









